import { reportMessages } from "~/features/treatment-report/i18n";

const messages = {
  "consents.title": "Dear doctor",
  "consents.intro": "To continue using your account, please read the <policy>Personal Data Processing Policy</policy> and give your consent below.",
  "consents.personal": "I <document>consent to the processing of my personal data</document>",
  "consents.marketing": "I <document>consent to receive advertising and informational messages</document>",
  "consents.footnote": "By giving consent, I confirm that I have read and accept the terms of the corresponding documents linked above.",
  "consents.personalRequired": "Please select the required “Consent to the processing of personal data” checkbox.",
  "consents.continue": "Continue",
  "consents.saving": "Saving…",
  "consents.loading": "Loading…",
  "consents.loadError": "Could not check your consents. Please try again.",
  "consents.saveError": "Could not save your consents. Please try again. Your selections are preserved in this dialog.",

  ...reportMessages.en,
  "pat.plan.report": "View report",
  // General
  "not.selected": "Not selected",
  None: "NA",

  None_V2: "NA",
  NA: "-",
  "table.search": "Search",
  "table.status": "Filter by status",
  "table.clear": "Clear",
  "table.from": "From",
  "table.to": "To",
  "button.all": "All",
  "button.save_changes": "Save changes",
  "general.payment.show": "Show payments",
  "general.payment.close": "Hide payments",
  "general.retry": "Retry",
  "bool.true": "Yes",
  "bool.false": "No",
  "word.and": "and",
  "select.option": "Select",
  date: "Date",
  millimetre: "mm",
  requiredField: "Required fields",
  "doctor.fullname": "Full name",
  "doctor.manager": "Manager",
  "doctor.profile.info": "Profile information",
  "doctor.fio.popup.title": "Dear Doctor,",
  "doctor.fio.popup.message": "Editing these fields is not available. To change them, please write to {email}",
  "deep_cbct.included.title": "Dear Doctor,",
  "deep_cbct.included.message": "The «Deep CBCT analysis» service is included in the selected course.",
  "not.found": "Not found",
  "click.to.copy": "Click to copy",
  next: "Next",
  previous: "Previous",
  cancel: "Cancel",
  fifty: "50",
  hundred: "100",
  "two.hundred": "200",
  here: "here",
  page: " page",
  loading: "Loading...",
  search: "Search",
  "search.clear": "Clear search",
  "error_boundary.title": "Error",
  "error_boundary.message": "Something went wrong",
  "error_boundary.message_1": " ",
  "error_boundary.message_2": "Try reloading the page or coming back later",
  "error_boundary.reset": "Try again",
  learn_more: "Learn more",
  scroll_to_top: "Scroll to top",
  profile_menu: "Profile menu",
  "alert.close": "Close",
  "telegram_id.required": "This field is required when subscribing to Telegram notifications",
  "email.incorrect": "Invalid email format",
  care_support: " ",
  "care_support.call": "Call",
  "care_support.write": "Write to a messenger",
  "care_support.dear.doctor": "Dear Doctor!",
  "care_support.description.1": "The customer service will promptly answer your questions.",
  "care_support.description.2": "Please choose a convenient way to contact us:",

  E_CONNECTION_FAILED: "Network connection error",

  // login page
  "login.header": "Doctor Account",
  "login.login": "Login",
  "login.password": "Password",
  "login.show_password": "Show password",
  "login.enter": "Login",
  "login.forgot": "Forgot your password ?",
  "login.forgot_cta": "Forgotten password?",
  E_INVALID_LOGIN: "Invalid credentials",
  // password reminder
  "reminder.forgot": "Restore password",
  "reminder.email": "Please enter your login or email address to restore password",
  "reminder.placeholder": "Email",
  "reminder.placeholder.login": "Login or Email",
  "reminder.back": "Back",
  "reminder.submit": "Send",
  "reminder.mail_send": "One-time link has been sent to your email",
  "reminder.link": "Go to login page.",
  "redesign.auth.email.placeholder": "Enter Email",
  "redesign.auth.password.placeholder": "Enter password",
  "redesign.auth.login.placeholder": "Enter login or email",
  "redesign.auth.recovery.hint": "Enter your login or email to receive a password-reset link",
  "redesign.auth.policy": "Privacy policy",
  "redesign.auth.contacts": "Contacts",
  "reminder.payment": "This is a friendly reminder that you have an open balance requiring your attention!",
  "reminder.payment.card": "If you have set up credit card payment, you can easily clear the balance by visiting the",
  "reminder.payment.invoice": "If you prefer to pay via invoice, please request it",
  "reminder.my.payments": '"My Payments"',

  "restore_password.success": "New password has been set. ",
  "restore_password.success_link": "Go to login page.",
  "restore_password.fail": "The link to restore your password has expired. Please, restart the procedure to restore your password. ",
  "restore_password.fail_link": "One-time link has been sent to your email",
  //tooltips
  tooltip_shipment: "Here you’re able to track the aligners' delivery",
  tooltip_payments: "",
  tooltip_payment: "You can always change the payment method of your patient if you go to Patients-Edit (at the end of the page) and then select the payment method",
  tooltip_notifications: "Here you receive all notifications",
  tooltip_3d_plan_approval_date: "Your aligners will be delivered within 15 business days after this date",
  tooltip_precise_first_comment: "First comment from 3D Precise - {labelTitle}  ",
  tooltip_precise_last_comment: "Latest comment from 3D Precise - {labelTitle}",
  "required.fields.tooltip":
    "All fields marked with an asterisk are mandatory as the more information we receive on your treatment goals, the more accurate 3D plan we will be able create. Regardless, if you don’t feel comfortable completing all non-mandatory fields, please know that our advanced AI will provide you with the best possible 3D plan based on Andrew's six keys of occlusion and anatomical boundaries.",
  "course.type.tooltip": "Case type is not only determined by length of treatment, but by movement type. Please refer to this ",
  "course.type.tooltip.sec": "If after the case has been submitted the case type needs to be adjusted, we will communicate it promptly to you.",
  "tooltip.chart": "chart",
  "upload.photos.tooltip": "High-quality pictures are crucial to treatment plan accuracy. Please see the ",
  "upload.photos.manual.tooltip": "manual",
  "cbct.upload.tooltip": "Click to see the video instruction how to upload CBCT files",
  "elastics.tooltip": "Optional for most movements. If you leave this field blank, our technician will inform you if they are needed upon creating the 3D plan",
  "tooltip.correction.btn.title": "The following conditions must be met in order to submit a correction: ",
  "tooltip.correction.btn.payment.status": "1.You must pay for the initial case.",
  "tooltip.correction.btn.warranty.date": "2.The number of refinements has not exceeded the allowed amount. ",
  "tooltip.correction.btn.error": "If these conditions have been met and you are unable to submit a refinement, please call ",
  "tooltip.corrcetion.btn.support": "To order a refinement, please reach out to support (the chat on the bottom right) to upgrade the case to 3D Smile Full and pay the difference",
  "tooltip.correction.btn.no.course": "Please submit a patient to be able to order correction",
  "tooltip.retainers": "You are not able to order retainers if your case type is “Retainers”. If you want to change it, please call ",
  "tooltip.support": "3D Smile Support",
  "tooltip.click.approve": "Сlick to approve",
  // Manager Info
  "manager_info.your_manager": "Your 3D Smile Manager",

  // Left menu
  "left.menu.header": "Doctor Account",
  "left.menu.patients": "Patients",
  "left.menu.add_patient": "Submit a patient",
  "left.menu.shipments": "My shipments",
  "left.menu.my_payments": "My payments",
  "left.menu.chat": "Chat",
  "left.menu.best_case": "Case of the quarter",
  "left.menu.library": "Library of clinical cases",

  // Top menu
  "top.menu.profile": "Profile",
  "top.menu.documents": "Documents",
  "top.menu.payment": "Payments",
  "top.menu.my_practices": "My Dental offices",
  "top.menu.add_practices": "Add Dental office",
  "top.menu.logout": "Log out",

  // Patient table header
  "pat_table.block_head": "Patients",
  "pat_table_tasks.block_head": "Current tasks",
  "pat_table.id": "ID",
  "pat_table.name": "Patient's name",
  "pat_table.delivered": "Steps delivered",
  "pat_table.received": "Payment received",
  "pat_table.tot_payment": "Total payment",
  "pat_table.payments": "Payments",
  "pat_table.status": "Patient's status",
  "pat_table.of": "out of",
  "pat_table.total": "Total",
  "pat_table.services": "Services",
  "pat_table_tasks.block_payments": "Payments",
  "pat_table.block_banners": "News",
  "pat_table.patients.not_found": "No patients found",

  // Clinics table header
  "clin_table.header": "My dental officeS",
  "clin_table.name": "Name",
  "clin_table.address": "Address",
  "clin_table.phone": "Phone number",
  "clin_table.email": "Email",
  "clin_table.contacts": "Contacts",
  // Clinic view/edit
  "clin_view.header": "DENTAL OFFICE INFORMATION",
  "clin_view.edit.header": "EDIT CLINIC",
  "clin_view.name": "Dental office",
  "clin_view.address": "Dental office address",
  "clin_view.phone": "Dental office phone number",
  "clin_view.zip": "Zip code",
  "clin_view.email": "Dental office email",
  "clin_view.contacts": "Contact details",
  "clin_view.add.header": "Add dental office",
  "clin_view.name.placeholder": "Name",
  "clin_view.address.placeholder": "Dental offices address",
  "clin_view.zip.placeholder": "Zip code",
  "clin_view.phone.placeholder": "Dental office phone number",
  "clin_view.email.placeholder": "Dental office email",
  "clin_view.logistic_phone.placeholder": "Phone number for delivery service (at most 15 characters are allowed)",
  "clin_view.logistic_contact.placeholder": "Contact for delivery service (at most 35 characters are allowed)",
  "clin_view.logistic_phone": "Phone number for delivery service",
  "clin_view.logistic_contact": "Contact for delivery service",
  "clin_view.contacts.placeholder": "Contact person for invoices and contracts ",
  "clin_view.add.button": "Add Dental office",
  "clin_view.confirm": "Do you really want to detach the dental office?",
  "clin_view.schedule.schedule": "Schedule",
  "clin_view.schedule.monday": "Monday",
  "clin_view.schedule.tuesday": "Tuesday",
  "clin_view.schedule.wednesday": "Wednesday",
  "clin_view.schedule.thursday": "Thursday",
  "clin_view.schedule.friday": "Friday",
  "clin_view.schedule.saturday": "Saturday",
  "clin_view.schedule.sunday": "Sunday",
  "clin_view.schedule.from": "From",
  "clin_view.schedule.to": "To",
  "clin_view.address.line.1": "Address Line 1",
  "clin_view.address.line.2": "Address Line 2",
  "clin_view.address.line.3": "Address Line 3",
  "clin_view.address.not.more.then.35": "(at most 35 characters are allowed)",
  "clin_view.address.line.1.placeholder": "Address Line 1",
  "clin_view.address.line.2.placeholder": "Address Line 2",
  "clin_view.address.line.3.placeholder": "Address Line 3",
  "clin_view.detach": "Detach",
  "clin_view.delivery.contacts": "Delivery contacts",
  "clin_view.administrative.contacts": "Administrative contacts",

  "clin_view.error.35.symbols": "At most 35 characters are allowed",
  "clin_view.error.phone": "Invalid phone number",
  "clin_view.error.email": "Invalid email format",
  "clin_view.error.index": "Invalid zip code format",
  "clin_view.error.logistic.phone": "At most 15 digits are allowed. Only digits are allowed.",
  "clin_view.error.logistic.contact": "At most 35 characters are allowed",
  clinics_not_found: "No records found",
  // Right blocks patient page
  "pat.block.not_found": "Patient not found",
  "pat.block.right.header": "Patient",
  "pat.block.right.id": "ID",
  "pat.block.right.name": "Name",
  "pat.block.right.instructions": "Submission date",
  "pat.block.right.plan_approval": "3D plan approval date",
  "pat.block.right.aligners.eta": "Aligners ETA",
  "pat.block.right.additional.eta": "Replacement aligners ETA",
  "pat.block.right.retainers.eta": "Retainers ETA",
  "pat.block.right.delivered": "Steps delivered",
  "pat.block.right.correction": "Treatment correction",
  "pat.block.right.additional_course": "Additional course",
  "pat.block.right.additional": "Next steps",
  "pat.block.right.general.treatment": "Main treatment",
  "pat.block.right.start_date": "Start date",
  "pat.block.right.plan_date": "3D-plan is to be ready",
  "pat.block.right.caps_date": "Aligners are to be sent",
  "pat.block.right.warranty_end_date": "Warranty end date",
  "pat.block.status.header": "PATIENT'S STATUS",
  "pat.block.deliveries.header": "DELIVERIES",
  "pat.block.impression.delivery.header": "IMPRESSIONS SHIPMENT",
  "pat.block.impression.delivery.all": "all shippings",
  "pat.deliveries.button.noWaybills": "Shipping labels were not found",
  "pat.block.deliveries.waybills": "Tracking number",
  "pat.block.status.status": "Status",
  "pat.block.payment.header": "PAYMENT STATUS",
  "pat.block.payment.status": "Payment status",
  "pat.block.payment.received": "Payment received",
  "pat.block.payment.total": "Total payment",
  "pat.block.payment.currency": "_",

  "pat.block.payment.currency.curr": "$",
  "pat.block.payment.payments": "Case",
  "pat.block.payment.extras": "Extra Services",
  "pat.block.payment.pay.all": "Pay for the course",
  "pat.deliveries.button.callACourier": "Schedule a pickup",
  "pat.deliveries.button.callACourierByPhone": "Call a courier by phone",
  "pat.deliveries.button.callCourier.confirmation": "Confirm",
  "pat.deliveries.button.getWaybill": "Create a shipping label",
  "pat.deliveries.button.getNewWaybill": "Create new shipping label",
  "pat.deliveries.button.cancel": "Cancel",
  "pat.block.deliveries.estimated.pickup_date": "Estimated pickup date",
  "pat.block.deliveries.current.pickups": "Track a package",
  "pat.block.deliveries.see.waybill": "(print shipping label)",
  "pat.block.deliveries.aligner.delivery": "Aligners delivery tracking number",
  "pat.block.deliveries.aligner.all": "all deliveries",
  "pat.block.deliveries.type": "Type",
  "pat.block.deliveries.type.laboratory": "Impressions shipment",
  "pat.block.deliveries.type.clinic": "Aligners delivery",
  "pat.block.deliveries.shipment.date": "Pickup date",
  "pat.block.deliveries.shipments.aligners": "Aligners Shipment",
  "pat.block.deliveries.deliveries.impressions": "Impressions Shipment",
  "pat.shipments.tracking_number": "Tracking number",
  "pat.block.deliveries.not_found": "Deliveries not found",
  "pat.block.shipments.not_found": "Shipments not found",
  "pat.shipments.eta": "Aligners ETA",
  "pat.shipments.header": "Shipments",
  "pat.shipments.description": "Here you can track the aligners' delivery. Usually, it takes 12 business days after 3D Plan approval",
  "pat.shipments.selected.date": "Start from",
  "notify.shipments.error": "Error occurred trying to fetch shipments",
  "pat.block.deliveries.ups.site.track": "Track the status of the shipment",
  "pat.deliveries.contact.to.manager": "Please contact your Sales representative to generate a shipping label",
  "pat.deliveries.error.E_INVALID_FROM": "Incorrect information",
  "pat.deliveries.error.E_UNHANDLED_ERROR": "Service temporarily unavailable",
  "pat.deliveries.error.E_SERVICE_UNAVAILABLE": "Service temporarily unavailable",
  "pat.payments.amount.to.pay": "Amount to be payed",
  "pat.payments.buttons.pay": "Proceed with payment",
  "pat.payments.buttons.submit": "Submit",
  "pat.payments.online.payment": "Online Payment",
  "pat.payments.you.will.be.redirected": "You will be redirected to the page of the payment form",
  "pat.payments.course.paid": "Payment completed successfully",
  "pat.payments.course.paid.error": "An error occurred during payment transaction",
  "pat.payments.course.pay.course": "Payments",
  "pat.payments.course.status.error": "Something went wrong loading payment status",
  "pat.payments.course.status.canceled": "Payment was canceled",
  "pat.payments.course.status.pending": "Payment has been created and is awaiting payment",
  "pat.payments.course.status.not_found": "Payment not found",
  "pat.retainers.page.header": "Retainers",
  "pat.power_cap.page.header": "Power cap",
  "pat.power_cap.block.header": "Power caps",
  "pat.power_cap.comment": "Diagnosis / Clinical condition / What result do you want to achieve?",
  "pat.power_cap.arches_select": "Choose the arches to make the power cap for",
  "pat.power_cap.linked": "Application {id}",
  "pat.power_cap.buttons.submit": "Send to work",
  "pat.power_cap.ship_with_retainers": "Ship together with the ordered retainers",
  "pat.power_cap.order_retainers": "Order retainers and ship them together with the power cap",
  "pat.power_cap.ships_with_retainers": "Ships together with retainers",
  "pat.power_cap.in_production_hint": "A power cap for this patient is already in production. You can order a new one once it is ready.",
  RETAINERS_COMMENT: "Comment",

  "pat.additional.aligners.page.header": "Replacement Aligners",
  "pat.payments.dear.doctor": "Dear Dr. ",
  "pat.payments.thanks": "Thank you ",
  "pat.payments.payment": "for your payment!",
  "pat.payments.invoice": "You’ll receive your invoice via email shortly",
  "pat.payments.payment_status.goto": "Go to patient",
  "pat.empty.comment": "Please, enter a comment",

  "notify.ok": "Ok",
  "notify.done": "Done",
  "pat.additional.aligners.add.stage": "Add stage",
  "pat.additional.aligners.required.fields": "Complete the required fields",
  "pat.additional.aligners.required.fields.remove.stage": "Complete the required fields or remove the additional stage",

  //Right blocks next step status
  FIRST_3D_PLAN: "Expected 3D-plan date",
  NEXT_3D_PLAN: "Expected 3D-plan date",
  FIRST_SHIPMENT: "Shipment expected",
  NEXT_SHIPMENT: "Next shipment",
  NEXT_SHIPMENT_PAYMENT_EXPECTED: "Waiting for payment",
  // Patient view-page-only blocks
  "pat.comment.header": "ADD COMMENT",
  "pat.comment.title": "Comments ",
  "pat.comment.placeholder": "Comment...",
  "pat.comment.button": "Add a comment",
  "pat.comments.hide": "Hide comments",
  "pat.comments.show": "See all comments",
  "pat.plan.header": "3D PLAN",
  "pat.plan.button": "View 3D plan",
  "pat.plan.link": "Share 3D plan",
  "pat.plan.copy_link": "Copy link",
  "pat.view.header": "PATIENT CARD",
  "pat.status.corr_stage": "Current step",
  "pat.status.button.correction": "Order correction",
  "pat.status.button.additional_course": "Order additional course",
  "pat.status.button.correction.new": "Order correction (New form)",
  "pat.status.button.retainers": "Order retainers",
  "pat.status.button.power_cap": "Order power cap",
  "pat.status.button.aligners.additional": "Replacement aligners",
  "pat.status.button.end": "Finish treatment",
  "pat.status.button.end.confirm": "Finish",
  "pat.status.button.end.description": "Are you sure you want to finish treatment of patient",
  "pat.status.button.confirm": "Confirmation",
  "pat.question.button": "Ask a clinical expert",
  "pat.question.modal.title": "Ask a clinical expert",
  "pat.question.modal.restricted.sym": 'The following characters "<" ">" cannot be used',
  "pat.comment.rework.header": "Please, leave a comment in the field below",

  // Status names
  S_UNFILLED_CASE: "Unfilled case",
  S_INSTRUCTIONS_PROCESSING: "Processing instructions",
  S_RETAKE_IMPRESSIONS: "Doctor's Input Required",
  S_WAITING_FOR_A_PAYMENT: "Waiting for payment",
  S_3D_SCANNING: "3D scanning",
  S_3D_PLAN_MODELING: "3D plan modeling",
  S_3D_PLAN_APPROVAL: "Approve 3D plan",
  S_3D_PLAN_MODELS_BUILDING: "Treatment in progress",
  S_PRODUCTION_PRINTING: "Treatment in progress",
  S_PRODUCTION_MOLDING: "Treatment in progress",
  S_PRODUCTION_MARKING: "Treatment in progress",
  S_PRODUCTION_ALLOCATING: "Treatment in progress",
  S_PRODUCTION_FABRICATING: "Treatment in progress",
  S_PRODUCTION_QUALITY_CONTROL: "Treatment in progress",
  S_FINAL_STAGE_READY: "Treatment in progress",
  S_TREATMENT_FINISHED: "Treatment finished",
  S_CANCEL_TREATMENT: "Cancelled treatment",
  S_RETAINERS_ORDERED: "Clear retainers ordered",
  S_RETAINERS_RETAKE_IMPRESSIONS: "Clear retainers doctor's input required",
  S_RETAINERS_WAITING_FOR_A_PAYMENT: "Clear retainers waiting for a payment",
  S_RETAINERS_PRINTING: "Clear retainers production",
  S_RETAINERS_FABRICATING: "Clear retainers production",
  S_RETAINERS_READY: "Clear retainers are ready",
  S_RETAINERS_3D_SCANNING: "Clear retainers production",
  S_POWER_CAP_ORDERED: "Power cap ordered",
  S_POWER_CAP_RETAKE_IMPRESSIONS: "Power cap — doctor's input required",
  S_POWER_CAP_WAITING_FOR_A_PAYMENT: "Power cap — waiting for payment",
  S_POWER_CAP_3D_SCANNING: "Power cap — scanning",
  S_POWER_CAP_3D_PLAN_MODELING: "Power cap — modeling",
  S_POWER_CAP_3D_PLAN_APPROVAL: "Approve power-cap plan",
  S_POWER_CAP_3D_PLAN_MODELS_BUILDING: "Power cap — STL",
  S_POWER_CAP_PRODUCTION_PRINTING: "Power cap — printing",
  S_POWER_CAP_PRODUCTION_MOLDING: "Power cap — molding",
  S_POWER_CAP_PRODUCTION_MARKING: "Power cap — marking",
  S_POWER_CAP_PRODUCTION_ALLOCATING: "Power cap — allocating",
  S_POWER_CAP_PRODUCTION_FABRICATING: "Power cap — fabricating",
  S_POWER_CAP_PRODUCTION_QUALITY_CONTROL: "Power cap — quality control",
  S_POWER_CAP_READY: "Power cap is ready",
  // Raw backend status sent without the `S_` prefix (not in the `Status` enum) — the status badge renders
  // it verbatim via `<FormattedMessage id={status} />`, so the message id is the bare string.
  // Value shared with the additional-service tag of the same name, below.

  // Create patient page
  BLOCKHEAD_DOCTOR: "Doctor's information",
  HEADER_DOCTOR: "Doctor",
  HEADER_CLINIC: "Dental office",
  CLINIC_SHIP_COMMENTS: "Shipment comments ",
  CLINIC_SHIP_COMMENTS_PLACEHOLDER: "Comments",
  BLOCKHEAD_PAYMENT: "Payment",
  HEADER_PAYMENT_METHOD: "Payment method",
  HEADER_PAYER: "Payer",
  HEADER_PROMO_CODE: "Promo code",
  HEADER_PROMO_CODE_PLACEHOLDER: "Enter the promo code (if any)",
  PAYER_CLINIC: "Clinic",
  PAYER_DOCTOR: "Doctor",
  PAYER_PATIENT: "Patient",
  PM_CASH: "Cash payment",
  PM_BANK: "Pay by invoice",
  PM_INVOICE: "Pay by invoice",
  PM_CARD: "Payment by credit card",
  PM_CARD_ONLINE: "Pay with credit card online",
  HEADER_PAYMENT_OPTION: "Payment option",
  PO_ADVANCE: "100% prepayment",
  PO_SPLIT_2: "2 step split payment",
  PO_SPLIT_2_2: " ",
  PO_SPLIT_3: "3 step split payment",
  PO_SPLIT_3_2: " ",
  PO_SPLIT_3_NO_OVERPAY: " ",
  "exclusive.payment_option": "2-step plan: 20 000 RUB for 3D plan + caps payment",
  "payment.caps_label": "Aligners payment",
  PO_CREDIT_SB: " ",
  PO_CREDIT_SB_COND: " ",
  PS_3D_PLAN: "3D plan payment received",
  PS_HALF_PRICE: "50% steps payment received",
  PS_FULL_PRICE: "All steps payment received",
  BLOCKHEAD_PAT_INFO: "Patient's information",
  PAT_INFO_LAST_NAME: "Last name",
  PAT_INFO_LAST_NAME_PLACEHOLDER: "Patient's last name",
  PAT_INFO_NAME_TOOLTIP: "Changing patient's name is not allowed after case submission",
  PAT_INFO_FIRST_NAME: "First name",
  PAT_INFO_FIRST_NAME_PLACEHOLDER: "Patient's first name",
  PAT_INFO_MIDDLE_NAME: "Middle name",
  PAT_INFO_MIDDLE_NAME_PLACEHOLDER: "Patient's middle name",
  PAT_EMAIL: "Payer's email",
  PAT_INFO_EMAIL_PLACEHOLDER: "Email",
  HEADER_SEX: "Gender",
  SEX_F: "Female",
  SEX_M: "Male",
  HEADER_BDATE: "Date of birth ",
  HEADER_CONDITION: "Patient's chief complaint / Сlinical condition ",
  CONDITION_PLACEHOLDER: "Patient's chief complaint / Clinical condition",
  BLOCKHEAD_INSTRUCTIONS: "Instructions",
  HEADER_INSTRUCTIONS: "Case type",
  "patient.form.course.title": "Choose a service",
  "patient.form.payment.title": "Payment method",
  ATTACHMENT_INSTRUCTIONS: "Choose one of the options",
  ADDITIONAL_INSTRUCTIONS: "Additional services",
  C_MATCHING: "Matching of CBCT with Scan",

  // Courses
  C_LIMITLESS: "Limitless",
  C_LIMITLESS_COMMENT: " (the course includes: Deep CBCT analysis, virtual 3D plan, unlimited number of stages and refinements, 1 pair of retainers)",
  C_TRANSPARENT: "Transparent",
  C_TRANSPARENT_COMMENT: " (CT included, 2-step plan: 20 000 RUB + aligners payment)",
  C_EXPERT: "Expert",
  C_EXPERT_COMMENT: " (the course includes: deep CBCT analysis, virtual 3D plan, unlimited main-plan stages, 3 corrections)",
  C_POWER_CAP: "Power cap",
  C_POWER_CAP_V2: "Power cap",
  C_POWER_CAP_COMMENT: " ",
  C_POWER_CAP_COMMENT_V2: " ",
  C_LIMITLESS_V2: "Limitless",
  C_LIMITLESS_COMMENT_V2: " (the course includes: Deep CBCT analysis, virtual 3D plan, unlimited number of stages and refinements, 1 pair of retainers)",
  // See the note in `ru.ts`: the name carries over per course, the per-version comment stays blank
  // until the copy for these price versions exists.
  C_LIMITLESS_V3: "Limitless",
  C_LIMITLESS_COMMENT_V3: " ",
  C_LIMITLESS_V4: "Limitless",
  C_LIMITLESS_COMMENT_V4: " ",

  C_FULL: "Unlimited",
  C_FULL_V2: "Unlimited",
  C_FULL_V3: "Unlimited",
  C_FULL_V4: "Unlimited",
  C_FULL_3_STEPS_CBCT_V2: "Unlimited",
  C_FULL_COMMENT: " ",
  C_FULL_COMMENT_V2: " ",
  C_FULL_COMMENT_V3: " ",
  C_FULL_COMMENT_V4: " ",

  C_TEEN: "Teen",
  C_TEEN_V2: "Teen",
  C_TEEN_V3: "Teen",
  C_TEEN_COMMENT: " (3D Plan, unlimited number of aligners, 3 refinements)",
  C_TEEN_COMMENT_V2: " ",
  C_TEEN_COMMENT_V3: " ",

  C_SHORT: "Short",
  C_SHORT_V2: "Short",
  C_SHORT_V3: "Short",
  C_SHORT_COMMENT: " (limited to 14 steps)",
  C_SHORT_COMMENT_V2: " (limited to 14 steps)",
  C_SHORT_COMMENT_V3: " (limited to 14 steps)",

  C_ONE_JAW: "Single arch",
  C_ONE_JAW_V2: "Single arch",
  C_ONE_JAW_V3: "Single arch",
  C_ONE_JAW_COMMENT: " ",
  C_ONE_JAW_COMMENT_V2: " ",
  C_ONE_JAW_COMMENT_V3: " ",

  C_SUPER_SHORT: "Super-short",
  C_SUPER_SHORT_COMMENT: " (limited to 8 aligners for one jaw)",
  C_SUPER_SHORT_V2: "Super-short",
  C_SUPER_SHORT_COMMENT_V2: " (limited to 8 aligners for one jaw)",

  C_UNLIMITED: "Unlimited with Deep CBCT analysis and roots movement",
  C_UNLIMITED_V2: "Unlimited with Deep CBCT analysis and roots movement",

  C_UNLIMITED_COMMENT: " ",
  C_UNLIMITED_COMMENT_V2: " ",

  C_3DSMILE_PRO: "3D Smile Pro",
  C_3DSMILE_PRO_COMMENT: " ",

  C_3D_PLAN: "3D Plan only",
  C_3D_PLAN_V2: "3D Plan only",

  C_3D_PLAN_COMMENT_V2: " ",

  C_CHILDREN: "Children",
  C_CHILDREN_V2: "Children",
  C_CHILDREN_V3: "Children",
  C_CHILDREN_V4: "Children",
  C_CHILDREN_COMMENT: " ",
  C_CHILDREN_COMMENT_V2: " ",
  C_CHILDREN_COMMENT_V3: " ",
  C_CHILDREN_COMMENT_V4: " ",

  C_CHILDREN_SHORT: " ",
  C_CHILDREN_SHORT_V1: " ",
  C_CHILDREN_SHORT_COMMENT: " ",
  C_CHILDREN_SHORT_COMMENT_V1: " ",

  C_RETAINERS: "Retainers",
  C_RETAINERS_V2: "Retainers",
  C_RETAINERS_V3: "Retainers",
  C_RETAINERS_COMMENT: " ",
  C_RETAINERS_COMMENT_V2: " ",
  C_RETAINERS_COMMENT_V3: " ",

  C_ADDITIONAL_ALIGNERS: "Replacement aligners",
  C_ADDITIONAL_ALIGNERS_V2: "Replacement aligners",
  C_ADDITIONAL_ALIGNERS_COMMENT_V2: " ",

  RETAINERS: "Retainers (2 pairs)",
  RETAINERS_ONE: "Retainers (1 pair)",
  RETAINERS_ONE_ARCH: "Retainers",
  RETAINERS_UPPER_ARCH: "Retainers / Upper Arch (2)",
  RETAINERS_UPPER_ARCH_ONE: "Retainers / Upper Arch (1)",
  RETAINERS_LOWER_ARCH: "Retainers / Lower Arch (2)",
  RETAINERS_LOWER_ARCH_ONE: "Retainers / Lower Arch (1)",
  RETAINERS_QUANTITY: "Number of retainer sets",
  POWER_CAP: "Power cap (both arches)",
  POWER_CAP_UPPER: "Power cap / upper arch",
  POWER_CAP_LOWER: "Power cap / lower arch",
  POWER_CAP_ONE_ARCH: "Power cap (one arch)",
  CBCT_ANALYSIS: "Deep CBCT",
  CBCT_ANALYSIS_3D_PLAN: "Deep CBCT",
  DELIVERY: "Shipping",
  PRESCRIPTION_TRANSCRIBING: "Expert support",
  PRESCRIPTION_WITH_EXPERT: "Expert support",
  FAST_3D_PLAN: "Expedited 3D Plan production",
  FAST_CAPS_PRINTING: "Expedited aligner production (printing)",
  LEAD_TECHNICIAN_3D_PLAN: "3D modeling by lead technician",
  "additional.services.add_to_course": "You can add to this course:",
  "additional.services.list.title": "Additional services:",
  "recipe.mode.question": "How would you like the prescription prepared?",
  "recipe.mode.self.title": "On your own",
  "recipe.mode.self.description": "Fill in the prescription the usual way. Set the treatment parameters, the movements you need " + "and your wishes for the future 3D plan yourself",
  "recipe.mode.expert.title": "Expert support",
  "recipe.mode.expert.badge": "New service",
  "recipe.mode.expert.price": "{price}",
  "recipe.mode.expert.blocked.no_course": "Select a service first — availability of this option depends on it",
  "recipe.mode.expert.blocked.unavailable": "This service is not available for the selected course",
  "recipe.mode.expert.description": "Describe the clinical task and the desired result. A clinical expert and lead technician will refine your clinical goals and implement them in the 3D plan.",
  "recipe.mode.expert.benefit.time.title": "Saves time",
  "recipe.mode.expert.benefit.time.text": "Delegate the routine prescription work to the laboratory — simply dictate the clinical task and important details by voice.",
  "recipe.mode.expert.benefit.voice.title": "Clinical expertise",
  "recipe.mode.expert.benefit.voice.text": "Before modelling, a clinical expert will review the prescription, ask clarifying questions if needed, and add important details.",
  "recipe.mode.expert.benefit.support.title": "Lead modelling technician",
  "recipe.mode.expert.benefit.support.text": "Your case is modelled by a lead modelling technician with deep expertise in aligner treatment planning.",
  "additional.services.smart.recipe.accordion_title": "Prescription",
  "additional.services.smart.recipe.accordion_subtitle": "Filled in from your recording",
  "additional.services.smart.tooltip.title": "Expert support",
  "additional.services.smart.tooltip.subtitle": "Delegate routine prescription processing to laboratory specialists.",
  "additional.services.smart.tooltip.how_it_works": "How it works:",
  "additional.services.smart.tooltip.description":
    "You no longer need to spend time on entering data and sorting attachments. " +
    "Just dictate the prescription by voice and upload all required files in one place. " +
    "We will do the rest: accurately fill in the prescription form, attach materials, " +
    "and prepare the prescription for final approval.",
  "additional.services.smart.audio.title": "Voice prescription input",
  "additional.services.smart.audio.recipe_title": "Tell us about the clinical task",
  "additional.services.smart.processing.title": "Recording is being processed",
  "additional.services.smart.processing.update_title": "Updating the prescription",
  "additional.services.smart.processing.step": "Step {number}:",
  "additional.services.smart.processing.audio.upload": "Uploading the voice prescription",
  "additional.services.smart.processing.audio.process": "Processing the recording",
  "additional.services.smart.processing.audio.analyze": "Analyzing the content",
  "additional.services.smart.processing.update.remove": "Removing the recording",
  "additional.services.smart.processing.update.recipe": "Updating the prescription",
  "additional.services.smart.processing.update.check": "Checking the changes",
  "additional.services.smart.audio.recording_now": "Recording audio",
  "additional.services.smart.audio.recording_hint":
    "What result do you want, which movements are planned, does the lower jaw position need to " + "change, what else matters: extractions, tremas, attachments or other specifics",
  "additional.services.smart.audio.recording_active_hint": "Maximum 15 min — Tap again to finish recording",
  "additional.services.smart.audio.recording_ending_hint": "{seconds}s left — recording will stop automatically",
  "additional.services.smart.audio.records_title": "All recordings",
  "additional.services.smart.audio.record_name": "Voice message {number}",
  "additional.services.smart.audio.speed_toggle": "Playback speed",
  "additional.services.smart.audio.status.empty": "Transcript is not available yet.",
  "additional.services.smart.audio.status.processing": "Transcribing...",
  "additional.services.smart.audio.status.ready": "Transcript is ready.",
  "additional.services.smart.audio.upload": "Upload audio",
  "additional.services.smart.audio.start_recording": "Press to record",
  "additional.services.smart.audio.stop_recording": "Stop recording",
  "additional.services.smart.audio.uploading": "Uploading audio...",
  "additional.services.smart.audio.file_uploaded": "Uploaded file: {fileName}",
  "additional.services.smart.audio.total_duration": "Total audio duration: {minutes} min {seconds} sec",
  "additional.services.smart.audio.duration_limit": "Total audio duration must not exceed 30 minutes.",
  "additional.services.smart.audio.transcript": "Prescription text",
  "additional.services.smart.audio.upload_error": "Failed to upload audio. Please try again.",
  "additional.services.smart.audio.processing_error": "Failed to process the audio. Remove the recording and try again.",
  "additional.services.smart.audio.unsupported_format": "Unsupported audio format. Please use OGG, MP3 or WAV.",
  "additional.services.smart.audio.recording_not_supported": "Audio recording is not supported by this browser.",
  "additional.services.smart.audio.recording_error": "Could not start recording. Please check microphone access.",
  "additional.services.smart.audio.mic_blocked": "The browser has blocked microphone access. Allow it in the site settings (the icon to the left of the page address) and start recording again.",
  "additional.services.smart.audio.mic_not_found": "No microphone found. Connect a microphone and start recording again.",
  "additional.services.smart.audio.mic_busy": "The microphone is in use by another application (for example, Zoom or Teams). Close it and start recording again.",
  "additional.services.smart.audio.mic_unavailable": "Could not turn on the microphone. Check that it is connected and access is allowed, then start recording again.",
  "additional.services.smart.generate_slow": "The model is taking longer than usual. It is still processing the recording — press “Check result” to check the result again.",
  "additional.services.smart.audio.remove_disabled_tooltip": "Removing is available only during patient creation",
  C_ANTHROPOMETRIC_DIAGNOSTIC: "Anthropometric analysis of 3D models (anthropometric diagnostic protocol of MSMSU)",
  C_ANTHROPOMETRIC_DIAGNOSTIC_ITEM: "Anthropometric analysis of 3D models (anthropometric diagnostic protocol of MSMSU)",
  C_IMPRESSIONS: "I will be taking PVS (A-silicone) impressions",
  C_SCAN: "I will be taking intraoral scan",
  C_TEST_PLASTIC_YES: "I will be using new plastic",
  C_TEST_PLASTIC_NO: "I will be using regular plastic",
  C_YES_CT_CORRECTION: "Correction will be with CT",
  C_NO_CT_CORRECTION: "Correction will be without CT",
  C_DEEP_CBCT_ANALYSIS: "Deep CBCT",
  C_DEEP_CBCT_ANALYSIS_ITEM: "Deep CBCT",
  HEADER_ARCHES: "Arches",
  ARCHES_SELECT: "Treat arches",
  TA_BOTH: "Both",
  TA_UPPER: "Upper",
  TA_LOWER: "Lower",

  TA_OCCLUSAL: " ",
  TA_P_OCCLUSAL: " ",
  TA_R_OCCLUSAL: " ",
  TA_L_OCCLUSAL: " ",
  TA_OCCLUSAL_SAVE: " ",
  TA_OCCLUSAL_MODIFY: " ",
  TA_OCCLUSAL_TEETH_EXTRUDE: " ",
  TA_OCCLUSAL_TEETH_INTRUDE: " ",
  ARCHES_U_SELECT: "Upper arch form",
  STAGE: "Stage",
  AMOUNT: "The number of aligners",
  UPPER_ARCH: "Upper arch",
  LOWER_ARCH: "Lower arch",
  SELECT_TREAT_ARCHES: "Treat arches",
  TA_U_MAINTAIN: "Maintain",
  TA_U_EXPAND: "Expand",
  TA_U_NARROW: "Narrow",
  TA_U_EXPAND_TYPE_TORQUE: "Tipping",
  TA_U_EXPAND_TYPE_BODILY: "Bodily",
  TA_U_EXPAND_TYPE_HOWTO: "Achieve with",
  TA_U_CORRECTION_BOTH: "tipping and bodily expansion",
  TA_U_CORRECTION_TORQUE: "tipping expansion",
  TA_U_CORRECTION_BODILY: "bodily expansion",
  ARCHES_L_SELECT: "Lower arch form",
  TA_L_MAINTAIN: "Maintain",
  TA_L_EXPAND: "Expand",
  TA_L_NARROW: "Narrow",
  ARCHES_TLA_UPPER: "Tooth alignment",
  ARCHES_TLA_LOWER: " ",
  TLA_G_MARGIN: "Gingival margin",
  TLA_C_EDGE: "Incisal edge",
  HEADER_INCISORS: "Desired incisor relationship",
  INCISORS_VO: "Overbite",
  VO_MAINTAIN: "Maintain",
  VO_DECREASE: "Decrease",
  VO_INCREASE: "Increase",

  VO_COMMENT: "How to change the depth",
  VO_COMMENT_PLACEHOLDER: "Enter type and volume of movement",
  INCISORS_HO: "Overjet",
  INCISORS_HO_U: "Upper incisors",
  HO_U_MAINTAIN: "Maintain",
  HO_U_RETROCLINATE: "Retroclination",
  HO_U_PROCLINATE: "Proclination",
  INCISORS_HO_L: "Lower incisors",
  HO_L_MAINTAIN: "Maintain",
  HO_L_RETROCLINATE: "Retroclination",
  HO_L_PROCLINATE: "Proclination",
  OVERJET: "Overjet",
  OJ_MAINTAIN: "Maintain",
  OJ_CONTACT: "Contact between incisors",
  OJ_MAINTAIN_LARGE: "Maintain large overjet if needed for Class",
  OJ_MAINTAIN_CORRECT: "Correct (create ideal contact between incisors)",
  OJ_MAINTAIN_CORRECT_SPECIFY: "(Optional). Would you like to specify the type of movements to achieve this correction?",
  DISPLACEMENT_LOWER: " ",
  CORRECT_RETROCLINATION_UPPER: "Retroclination of Upper incisors",
  CORRECT_PROCLINATION_LOWER: "Proclination of Lower incisors",
  CORRECT_PROCLINATION_UPPER: "Proclination of Upper incisors",
  CORRECT_RETROCLINATION_LOWER: "Retroclination of Lower incisors",
  MIDLINE: "Midline",
  ML_MAINTAIN: "Maintain",
  ML_ADJUST_LOWER_TO_UPPER: "Adjust lower to the upper (upper used as guidance)",
  ML_ADJUST_UPPER_TO_LOWER: "Adjust upper to the lower (lower used as guidance)",
  ML_IMPROVE: "Improve by (list of required movements)",
  HEADER_CANINE: "Desired canine relationship",
  HEADER_CANINE_DESCRIPTION: " ",
  CANINE_RIGHT: "Right",
  CR_R_I_CLASS: "Class I",
  CR_R_II_CLASS: "Class II",
  CR_R_III_CLASS: "Class III",
  CANINE_LEFT: "Left",
  CR_L_I_CLASS: "Class I",
  CR_L_II_CLASS: "Class II",
  CR_L_III_CLASS: "Class III",
  CANINE_HOWTO: "Achieve class with",
  CRH_DISTALIZE: "Distalization",
  CRH_MESIALIZE: "Mesialization",
  CRH_IPR: "IPR",
  CRH_AI: "Let the AI and technician determine the best option",
  CRH_SPECIFY: "I would like to specify how to achieve it",
  HEADER_MOLAR: "Desired molar relationship",
  HEADER_MOLAR_DESCRIPTION: " ",
  MOLAR_RIGHT: "Right",
  MR_R_MAINTAIN: "Maintain",
  MR_R_I_CLASS: "Class I",
  MR_R_II_CLASS: "Class II",
  MR_R_III_CLASS: "Class III",
  MOLAR_LEFT: "Left",
  MR_L_I_CLASS: "Class I",
  MR_L_II_CLASS: "Class II",
  MR_L_III_CLASS: "Class III",
  MOLAR_HOWTO: "Achieve class with",
  MRH_DISTALIZE: "Distalization",
  MRH_MESIALIZE: "Mesialization",
  MRH_IPR: "IPR",
  MRH_AI: "Let the AI and technician determine the best option",
  IPR_TRUE: "Use IPR",
  HEADER_ELASTICS: "Elastics",
  HEADER_ELASTICS_DESCRIPTION: "3D Smile’s technology allows for a large range of movement volume, thus additional appliances are rarely needed. For more details please refer to this ",
  ELASTICS_RIGHT: "Right",
  ER_R_I_CLASS: "Class I",
  ER_R_II_CLASS: "Class II",
  ER_R_III_CLASS: "Class III",
  ER_NONE: "None",
  ELASTICS_LEFT: "Left",
  BUTTONS_AND_HOOKS: "Use hooks or buttons",
  BUTTON: "Button",
  HOOK: "Hook",
  CANCEL: "click to remove",
  ER_L_I_CLASS: "Class I",
  ER_L_II_CLASS: "Class II",
  ER_L_III_CLASS: "Class III",
  HEADER_CLOSE_ALL: "Close all spaces",
  CAG_YES: "Yes",
  CAG_MAINTAIN: "Maintain diastema / trema",
  CAG_LEAVE_SPACE: "Leave space distal to :   ",
  CAG_LEAVE_SPACE_FOR: "Leave space for",
  CAG_LEAVE_SPACE_ADD_COMMENT: "Any additional comments",
  TOOTH_NUMBER: "tooth",
  TOOTH_NUMBER_PLACEHOLDER: "Specify tooth number",
  DISTANCE_IN_MILLIMETRES: "distance in millimetres",
  DISTANCE_IN_MILLIMETRES_PLACEHOLDER: "Enter the distance in millimetres *",
  MILLIMETRES: "mm",
  ADD_FIELD: "Add field",
  CAG_LEAVE_SPACE_COMMENT: "(specify tooth and space in millimetres)",
  EXTRA_NOMOVE: "Do not move these teeth (bridges, ankylosed teeth, implants, etc.)",
  EXTRA_NOLOCK: "Avoid attachments on these teeth (facial restorations, crowns, veneers, etc.)",
  EXTRA_EXTRACT: "I want to extract these teeth",
  EXTRA_HOOK: "Cut a hook on these teeth",
  EXTRA_BUTTON: "I will bond buttons on these teeth",
  EXTRA_TEETHING: "To leave the place for a teething",
  EXTRA_COMMENTS: "Treatment goals / RX ",
  treatment_goals_ex: "click to see examples for the field",
  treatment_goals_ex_1: "Chief complaint is anterior crowding. Please align anterior teeth. Correct overbite and overjet within limits of patient’s anatomy.",
  treatment_goals_ex_2: "Treatment goal is to align midlines and achieve class I molar. Note upper midline in on to the face so please match lower midline to it as much as possible.",
  treatment_goals_ex_3: "Treatment goal is to make space for implant to replace #4. Space needed for crown restoration after implant is 7 mm.",
  EXTRA_COMMENTS_PLACEHOLDER: "Comments",
  UPLOADED_FILES: "STL, Photos, OPG and other media",
  UPLOADED_CBCT: "CBCT files",
  CBCT_LINKS: "CBCT links",
  LINK: "Link",
  CREATED_AT: "Added",
  OPEN: "Copy",
  UPLOAD_FILES: "Upload STL, panoramic and other records",
  "patient.files.other_materials": "Other patient materials",
  "patient.files.other_materials_hint": "Upload STL, photos, OPG, CBCT (in a ZIP archive or by link) and other files",
  "patient.files.dropzone.hint": "Drag the files into this area or pick them on your device. " + "Several files can be uploaded at once",
  "patient.files.dropzone.hint_mobile": "Pick several files on your device, or upload them one by one into the fields below",
  "patient.files.dropzone.choose": "Choose files",
  "patient.files.clear_all": "Clear all",
  "patient.files.ct_link_label": "CBCT link (DICOM)",
  "patient.files.uploaded_title": "Uploaded files",
  "patient.files.size.mb": "MB",
  "patient.files.size.kb": "KB",
  "patient.files.size.bytes": "B",
  UPLOAD_FILES_SMART: "Upload all required files (STL, photos, panoramic and other records)",
  UPLOAD_FHOTOS: "Pre-treatment photos",
  ADD_LINK_TO_CT: "CBCT link",

  COMING_SOON: "Coming soon...",

  LINK_TO_MANUAL: "Open a manual",
  UPLOAD_BTN: "Upload image",
  UPLOAD_FILE_BTN: "Upload files",
  FILE_UPLOAD_REMOVE: "Remove file",
  FILE_UPLOAD_UPLOADING: "Uploading\u2026",
  DISK_CBCT: "CBCT files on a disk",
  PHOTO_PROFILE: "Profile (not smiling)",
  PHOTO_SMILE: "Full face (smiling)",
  PHOTO_PORTRATE: "Full face (not smiling)",
  PHOTO_UPPER_OCCLUSAL: "Upper occlusal",
  PHOTO_LOWER_OCCLUSAL: "Lower occlusal",
  PHOTO_RIGHT: "Right view",
  PHOTO_FRONT: "Front view",
  PHOTO_LEFT: "Left view",
  // In-browser photo classifier (docs/features/photo-classifier.md)
  "photo_classifier.loading": "Preparing photos…",
  "photo_classifier.preparing": "Preparing photos…",
  "photo_classifier.classifying": "Recognizing and sorting photos…",
  "photo_classifier.rotate_left": "Left",
  "photo_classifier.rotate_right": "Right",
  "photo_classifier.flip_horizontal": "Flip horizontally",
  "photo_classifier.flip_vertical": "Flip vertically",
  "photo_classifier.expand_photo": "Enlarge photo",
  "photo_classifier.remove_photo": "Remove photo",
  "photo_classifier.limit_hint": "You can add up to {max} photos.",
  "photo_classifier.limit_reached": "The {max}-photo limit has been reached. Remove one before adding another.",
  "photo_classifier.protocol_hint": "Upload the patient's photos from every required angle",
  "photo_classifier.auto_detect_badge": "The view of each photo is detected automatically and placed into the right slot",
  "photo_classifier.upload_into_slot": "Upload a photo: {view}",
  "photo_classifier.photo_index": "{index} of {total}",
  "photo_classifier.prev_photo": "Previous photo",
  "photo_classifier.next_photo": "Next photo",
  "photo_classifier.unavailable_browser":
    "Automatic photo recognition is unavailable: your browser does not support the required technologies. Please update it to the latest version. You can upload the photos manually — one per view.",
  "photo_classifier.unavailable_config":
    "Automatic photo recognition is unavailable because of security settings. Please contact technical support. You can upload the photos manually — one per view.",
  "photo_classifier.unavailable_slow": "Automatic photo recognition is unavailable: it runs too slowly on this device. You can upload the photos manually — one per view.",
  "photo_classifier.unavailable_error": "The photos could not be recognised because of an internal error. Please contact technical support. You can upload the photos manually — one per view.",
  PHOTO_BEFORE: "Before",
  PHOTO_CORRECTION: "Correction",
  BTN_ADD_FILES: "Add files",
  BTN_CHOOSE_FILES: "Choose files",
  BTN_CHOOSE_PHOTO: "Choose photo",
  BTN_SUBMIT: "Submit",
  BTN_SUBMIT_NEW: "Submit",
  BTN_EDIT: "Edit",
  PAYMENT_DATA: "Payment data",
  BTN_CHANGE_PASSWORD: "Change password",
  BTN_SAVE: "Save",
  BTN_SAVE_DRAFT: "Save as a draft",
  BTN_SAVE_DRAFT_CONTINUE_LATER: "Save as a draft and continue later?",
  BTN_SAVE_CONTINUE_LATER: "Save and continue later?",
  REQUIRED_FIELDS_FOR_A_DRAFT: "Please complete the required fields",
  EXIT_WITHOUT_SAVING: "Exit without saving?",
  STAY_HERE: "Stay here",
  CBCT_UPLOAD_HEADER: "Upload CBCT files",
  CBCT_UPLOADED_HEADER: "Uploaded files",
  HOW_UPLOAD_CBCT: "How to upload CBCT files",
  CBCT_DETAILS: "Click for details",
  CBCT_UPLOAD_PROGRESS_TITLE: "Uploading {filesCount} file(s)",
  CBCT_UPLOAD_COMPLETE: "Upload complete",
  CBCT_UPLOAD_ERROR: "Upload error",
  SCAN_UPLOAD_SCAN_WARNING: "Don’t forget to upload the scan",
  SCAN_UPLOAD_CT_WARNING: "Don’t forget to upload the CBCT",
  "3D_SMILE_PRO_WARNING": " ",
  ADDITIONAL_ALIGNERS: "Replacement aligners",
  ADDITIONAL_ALIGNERS_TRANSPARENT: "Replacement aligners",
  SAA_PROCESSING: "Processing",
  SAA_READY: "Replacement aligners are ready",
  "all.additional.aligners": "all replacement aligners",
  "additional.aligners.patients": "Separate cases",

  // Footer
  "page.footer.header": "© OOO «3D Smile».",
  "page.footer.content": "3D Smile. High technologies for tooth movement!",

  "page.footer.contacts": "Contacts",
  "page.footer.payment": "Payment",
  "page.footer.version": "Version",
  "plan.approve.header": "Approve 3D-plan",
  "plan.approve.body": "Approve plan:",
  "plan.approve.btn": "Approve",
  "plan.confirm_plan.btn": "Confirm",
  "plan.approve.no_clinic": "The patient profile does not include a dental office.",
  "plan.approve.redirect": "Go to profile",
  "plan.approve.accept": "I confirm that I have read and agree to the Terms and Conditions",
  "plan.approve.postpone": "Postpone confirmation",
  "plan.rework.header": "Adjust 3D-plan",
  "plan.rework.body": "Plan ID:",
  "plan.rework.btn": "Adjust",
  "plan.cancel.header": "Correct 3D-plan",
  "plan.cancel.body": "3D-plan:",
  "plan.cancel.stage": "Step number",
  "plan.cancel.scroll.to.field": "Click to edit",
  "plan.cancel.btn": "Submit",
  "plan.cancel.opt_out_test_plastic.description": "Are you sure you <bold>don't want</bold> to use new plastic to continue your treatment?",
  "plan.order.btn": "Order",
  "change.password": "Change password",
  "change.password.match": "The passwords don't match",
  "enter.password": "Enter new password",
  "re-enter.password": "Re-enter new password",
  "treatment.correct.header": "Adjust treatment",
  "treatment.additional_course.header": "Additional course",
  "correction.ct.notifcation": "CBCT file was uploaded",
  "recipe.check.title": "Required fields",
  "recipe.check.reference.steps": "Indicated step #",
  "recipe.check.reference.photos": "Uploaded photos",
  "recipe.check.reference.material": "Chose to use scans or impressions",
  "recipe.check.reference.arches": "Chose to treat both or one of the arches",
  "recipe.check.reference.correction_with_ct": "Correction with CT or not",

  "Ляшук Даниил": "Lyashuk Daniil",
  "Аптекарев Федор": "Aptekarev Fedor",
  "Дмитриенко Ирина": "Dmitrienko Irina",
  "Сосин Михаил": "Sosin Mikhail",

  "notify.doctor.update.success": "Information has been updated",
  "notify.doctor.update.error": "Error. Login already exists",
  "notify.doctor.password.success": "Password was successfully changed",
  "notify.doctor.password.failed": "Password change failed",
  "notify.comment": "Comment has been added",
  "notify.comment.error": "Error occurred trying to save comment",
  "notify.question": "Question has been sent",
  "notify.question.error": "Error occurred trying to send question",

  "notify.patient.create.ok": "A new patient has been created",
  "notify.patient.submit.draft.error": "The draft was saved, but submission failed. Please try again.",
  "notify.patient.create.error": "Creation error",
  "notify.patient.create.draft.patient": "A patient ",
  "notify.patient.create.draft.ok": " has been saved as a draft, you can continue filling out the prescription in Patients",
  "notify.patient.update.ok": "Patient successfully updated",
  "notify.patient.update.error": "Patient update error",

  "notify.meeting.reschedule.ok": "Meeting successfully rescheduled",
  "notify.meeting.reschedule.error": "There was an error rescheduling the meeting",

  "notify.meeting.cancel.ok": "Meeting successfully cancelled",
  "notify.meeting.cancel.error": "There was an error cancelling the meeting",

  "notify.add_clinic.ok": "Dental office list was updated",
  "notify.add_clinic.error": "An error occurred trying to attach dental office",

  "notify.unlink_clinic.ok": "Dental office has been detached",
  "notify.unlink_clinic.error": "Error occured trying to detach dental office",

  "notify.correction.create.ok": "A new correction was created",
  "notify.form.submitted.ok": "for submitting the form!\nWe'll get back to you shortly",
  "notify.correction.create.error": "An error occurred trying to order correction",
  "notify.correction.thanks": "Thank you for using the new form to order correction. Feel free to share your feeedback feedback@3d-smile.com",

  "notify.status_end.ok": "Case has been finished successfully",
  "notify.status_end.error": "Error occurred trying to finish treatment",

  "notify.retainers.ok": "The retainers was ordered",
  "notify.retainers.error": "Retainers order error",
  "notify.power_cap.error": "Power cap order error",

  "notify.additional.aligners.ok": "Replacement aligners has been ordered",
  "notify.additional.aligners.error": "An error occurred during ordering replacement aligners",

  "notify.approve.ok": "3D Plan has been approved",
  "notify.approve.error": "Error occurred while trying to approve 3D plan",

  "notify.rework.ok": "Thank you for your comments. {labelTitle} technician is already working on your 3D Plan updates",
  "notify.rework.error": "Error occurred trying to adjust 3D Plan",

  "notify.doctor.subscribe": "Notification",
  "notify.doctor.subscribe.edit": "Subscription to notifications:",

  "notify.link_copy": "Link copied to clipboard",
  "notify.link_tg": "Link sent via Telegram",
  "notify.link_email": "Link sent via email",
  "notify.link_tg_email": "Link sent via Telegram and email",

  "notify.send_password.EMAIL_SENT": "A one-time password has been sent to your email address",
  "notify.send_password.E_EMAIL_OR_LOGIN_REQUIRED": "Please specify your email address or login",
  "notify.send_password.E_EMAIL_NOT_FOUND": "Your email address wasn't found",
  "notify.send_password.E_LOGIN_NOT_FOUND": "Your login wasn't found",
  "notify.send_password.SENDING_ERROR": "Error has occurred sending restore link. Please, check data.",
  "notify.send_password.SENDING_RESTORE_SUCCESS": "Restore link has been sent to your email",

  "notify.login.SUCCESS": "SUCCESS",
  "notify.login.E_PASSWORD_RESET": "Please, set a new password",
  "notify.login.E_INVALID_AUTH": "Incorrect login or password",

  "notify.upload.E_UNSUPPORTED_FORMAT": "The format of the file that you are uploading is not supported. Please, upload the file in JPEG format.",
  "notify.upload.E_UNSUPPORTED_FORMAT_EXT": "The file format is not supported. Upload a JPG, JPEG, PNG, STL, PDF, ORTHO, or MP4 file.",
  "notify.upload.E_UNSUPPORTED_FORMAT_EXT_WITH_ARCHIVE": "The file format is not supported. Upload a JPG, JPEG, PNG, STL, PDF, ORTHO, MP4, ZIP, or RAR file.",
  "notify.upload.E_UNSUPPORTED_FORMAT_CBCT": "The format of the file that you are uploading is not supported. Please, upload compressed file in one of the following formats: ZIP, RAR.",
  "notify.upload.E_FILE_TOO_BIG_CBCT": "File size should be less than 1.5 GB.",
  "notify.upload.E_PATIENT_FILE_TOO_BIG": "File size should be less than {maxFileSizeMb} MB.",
  "notify.patient.required_fields": "Complete the required fields. The form has moved to the first missing field.",

  "new_password.header": "You entered with temporary password. Please set new password.",
  "new_password.header_key": "Please, enter a password that contains at least 10 characters including at least one number, uppercase and lower case letters and at least one special character.",
  "new_password.new_password": "New password",
  "new_password.confirm": "Confirm password",
  "new_password.button": "Save",

  Privacy: "Privacy",

  nocorrection: "No prescription for this correction",
  correction: "Correction",
  "main.treatment": "Main treatment",
  "correction.material": "Impressions",
  "correction.impressions.new": "New impressions / intraoral scan are taken",
  "correction.impressions.old": "No new impressions (modeling based on last stage)",
  "correction.reason": "Correction cause",
  "correction.plan_type": "Which instructions to use to continue treatment",
  "correction.failed.teeth": "Planned movement was not achieved on the following teeth",
  "correction.old_plan": "Continue based on initial instructions",
  "correction.new_plan": "Correct instructions",
  "correction.information_correct": "Information is entered correctly",

  "correction.comment.title": "Order mid term correction",
  "correction.comment.plan": "Plan:",
  "correction.comment.tooth": "Tooth",
  "correction.comment.stage": "Stage:",
  "correction.comment.arches.both": "Both arches",
  "correction.comment.arches.upper": "Upper arch",
  "correction.comment.arches.lower": "Lower arch",
  "correction.comment.casts.new": "New impressions will be taken",
  "correction.comment.casts.old": "Modeling should be done based on the last stage",
  "correction.comment.impressions.scan": "New impressions will be taken (intraoral scan)",
  "correction.comment.impressions.impression": "New impressions will be taken (impressions)",
  "correction.comment.movment_1": "Failure to follow doctor's prescription",
  "correction.comment.movment_2": "Movement not achieved",
  "correction.comment.movment_type_0": "movement not chosen",
  "correction.comment.movment_type_1": "Intrusion",
  "correction.comment.movment_type_2": "Extrusion",
  "correction.comment.movment_type_3": "Rotation",
  "correction.comment.movment_type_4": "Mesialization",
  "correction.comment.movment_type_5": "Distalization",
  "correction.comment.movment_type_6": "Torque",
  "correction.comment.movment_type_7": "Angulation",
  "correction.comment.movment_type_8": "Vestibular",
  "correction.comment.movment_type_9": "Oral",
  "correction.comment.correct_plan_1": "Continue treatment based on the initial instructions",
  "correction.comment.correct_plan_2": "Continue treatment based on the new instructions",

  preferences: "Clinical Preferences",
  "preferences.ipr": "IPR",
  "preferences.ipr_enabled": "Perform IPR",
  "preferences.ipr_start_step": "Start IPR on step",
  "preferences.attachments": "Attachments",
  "preferences.attachments_delay": "Place attachments on step",
  "preferences.attachments_deprecated_teeth": "Never place attachments on teeth",
  "preferences.expansion": "Expansion",
  "preferences.always_expand": "Always expand",
  "preferences.incisor_relationship": "Incisor relationship",
  "preferences.incisor_relationship.overjet": "Incisor relationship: overjet, mm",
  "preferences.incisor_relationship.overbite": "Incisor relationship: overbite, mm",
  "preferences.upper_incisor_angulation": "Upper incisors torque (inclination), degrees",
  "preferences.additional_notes": "Additional notes",
  "preferences.additional_notes.sub": "Other clinical preferences for most of your cases",
  "preferences.overcorrection": "Overcorrection",
  "preferences.deep_bite_intrusion": "Intrusion (deep bite) +1 mm",
  "preferences.incisors_extrusion": "Incisors extrusion +1 mm",
  "preferences.rotation_over_30dg": "Rotation over 30deg +5",
  "correction.exclusive.info.title": "Correction payment",
  "correction.exclusive.info.text":
    "For this course, a correction is an additional paid service: the first payment of 15 000 RUB covers the 3D correction plan; the second payment for all aligners in the correction plan is calculated individually after the plan is approved.",

  "comment.message.on.plan.approve": "You can leave a comment regarding the provided 3D-plan while viewing it",

  "comment.on.3dplan.adjustment": "3D Plan comment. Version",
  COMMENT_TYPE_CE_QUESTION: "Question to a clinical expert",
  COMMENT_TYPE_CORRECTION: "Correction instructions",
  COMMENT_TYPE_REWORK: "3D Plan comment",
  COMMENT_TYPE_REWORK_PRESICE: "3D Plan comment / 3D Precise",
  COMMENT_TYPE_ORDER_RETAINERS: "Retainers",

  "offer.header": "Public Offer Agreement",

  "offer.accept": "I confirm that I have read, understand and agree to the Public Offer Agreement",
  "offer.confirm_plan.btn": "Confirm",
  "offer.pdf_error": "Something went wrong while loading the offer",
  "notify.doctor.offer.error": "Error was occurred while trying to accept an offer",
  "notify.doctor.offer.success": "Offer has been successfully accepted",
  "page.footer.offer": "Public Offer Agreement",

  "manuals.title": "Manuals",
  "redesign.instructions.search": "Search by name...",
  "manuals.empty.query": "No published manuals on your language yet.",

  "promo.title": "Promo for patients",
  // Redesign promo heading; the legacy page uses `promo.title` above.
  "redesign.promo.title": "Patient materials",
  "promo.empty": "No published promo materials in your language yet.",
  "promo.download": "Download",
  "manuals.loading": "Loading...",
  "notify.patient.payment_link.error": "Error was occurred while trying to process payments",
  "patient.area.payments.paid": "Payment is successfully processed",
  "another.payer.person": "Please, specify payer's full name if payer is not the patient",
  PAYER_LAST_NAME: "Last name",
  PAYER_LAST_NAME_PLACEHOLDER: "Payer's last name",
  PAYER_FIRST_NAME: "First name",
  PAYER_FIRST_NAME_PLACEHOLDER: "Payer's first name",
  PAYER_MIDDLE_NAME: "Middle name",
  PAYER_MIDDLE_NAME_PLACEHOLDER: "Payer's middle name",

  E_LOGIN_REQUIRED: " ",
  EXTRA_SERVICE_OPTION_LAST_STAGE: "Use the patient’s last 3D Plan stage",
  EXTRA_SERVICE_OPTION_USE_SCAN: "I will be taking intraoral scan",
  EXTRA_SERVICE_OPTION_USE_IMPRESSIONS: "I will be taking PVS (A-silicone) impressions",

  //Doctor payments info
  "payments.account.delete.err": "Error occurred while trying to remove payment information",
  "payments.doctor.total": "Total:",

  //Additional Aligners Table
  "th.stage": "Stage",
  "th.amount": "Amount",
  "th.option": "Arches",
  "th.status": "Status",
  "th.timestamp": "Order date",

  // Additional Aligners
  "additional_aligners.patient.label": "Patient",
  "additional_aligners.patient.placeholder": "Select a patient",
  "additional_aligners.patient.not_found": "Patient not found",
  "additional_aligners.patient.none": "No patients available for replacement aligners order",
  "additional_aligners.stage.description": "Before selecting a stage, you need to select a patient",
  "additional_aligners.stage.delete": "Delete stage",
  "additional_aligners.not_found": "Replacement aligners not found",

  SCAN: "Scan file",
  CAD: "Cad file",
  CAM: "Cam file",
  MILLING: "Milling file",
  ATTACHED: "Attached file",
  "patient.search.placeholder": "Start typing a patient name or ID",

  "bonus.patient": "Free case",
  "bonus.period": "Promotion period",
  "bonus.period.hint": "Bonus-program period: patients added within this range count toward earning free cases.",
  "bonus.patients": "Free cases",
  "bonus.patients.total": "Cases:",
  "bonus.patients.total.hint": "Cases counted toward the bonus program.",
  "bonus.all.cases": "All cases",
  "bonus.cases.left": "cases added",
  "bonus.cases.left.1": "from",
  "bonus.cases.left.2": "patients",
  "bonus.case.chosen": "Free case was used",
  "bonus.case.not.chosen": "Free case was not chosen",
  "bonus.patient.set.successfully": "Patient is set as bonus successfully",
  "bonus.patient.set.error": "Error occurred choosing bonus patient",
  "bonus.patient.btn": "Free case",
  "bonus.patient.btn.confirm": "Free case",
  "bonus.patient.btn.description.1": "Are you sure you want to select patient",
  "bonus.patient.btn.description.2": "as a free case",
  "bonus.period.end.days": "days till end of promotion period",
  "bonus.period.end.months": "months till end of promotion period",
  "bonus.patient.activation": "cases to go till Free case",
  "bonus.patient.activation.one": "case to go till Free case",
  "bonus.patient.activation.more": "cases to go till Free case",
  "bonus.patient.activation.a.lot": "cases to go till Free case",
  "bonus.full.coin.title": "Your Free case is now available",
  "bonus.hint.available": "{count, plural, one {Bonus patient available to order.} other {Bonus patients available to order.}}",
  "bonus.hint.until.activation": "{count, plural, one {Patient until the next bonus activates.} other {Patients until the next bonus activates.}}",

  // bonuses page
  "bonuses.page.title": "Loyalty program",
  "bonuses.page.choose.event": "",

  "geo.city": "City",

  "login.error": "Incorrect login or password",
  "password.recovery.invalid.link": "Link is invalid or expired",
  "password.recovery.title": "Password recovery",

  "password.requirements.header": "Please, enter password that matches following requirements",
  "password.requirements.digits": "contains digits",
  "password.requirements.upper.chars": "contains uppercase letters",
  "password.requirements.lower.chars": "contains lowercase letters",
  "password.requirements.length": "consist of at least 10 characters",
  "password.requirements.special": "contains special characters",
  "password.requirements.match": "entered passwords match",
  "password.requirements.similar": "not too similar to your login",
  "public.plan.error": "Error occurred trying to get public link",

  "p.patient.correction.stages": "Steps",

  "meetings.heading": "Consultations with a clinical expert",
  "meetings.new": "New meeting",
  "meetings.enrolled.title.upcoming": "My upcoming meetings",
  "meetings.enrolled.title.finished": "My finished meetings",
  "meetings.enrolled.title.all": "My meetings",
  "meetings.tabs.new": "New meeting",
  "meetings.tabs.upcoming": "Upcoming",
  "meetings.tabs.finished": "Finished",
  "meetings.tabs.all": "All",
  "meetings.calendar": "Calendar",
  "meetings.add_to_calendar": "Add {br}to calendar",
  "meetings.reschedule": "Reschedule meeting",
  "meetings.cancel": "Cancel meeting",
  "meetings.cancel.heading": "Are you sure you want to cancel the meeting?",
  "meetings.cancel.description.expert": "<b>Clinical expert:</b> {expertName}",
  "meetings.cancel.description.datetime": "<b>Date:</b> {date} at {time}",
  "meetings.cancel.reason": "Cancel reason",
  "meetings.reschedule.reason": "Reschedule reason",
  "meetings.reschedule.heading": "Are you sure you want to reschedule the meeting?",
  "meetings.enter.cancel.reason.placeholder": "Enter cancel reason",
  "meetings.enter.reschedule.reason.placeholder": "Enter reschedule reason",
  "meetings.detail": "Details",
  "meetings.your_question": "Your question",
  "meetings.expert_comment": "Expert's comment",
  "meetings.datetime": "Date and time",
  "meetings.expert_comment_default": "Expert's comment will appear here...",
  "meetings.join": "Join",
  "meetings.expert": "Clinical expert",
  "meetings.not.found": "Schedule is not found",
  "meetings.not.found.description": "Clinical experts available for appointment will be displayed here",
  "meetings.error": "Error loading schedule",
  "meetings.title": "Contact clinical expert",
  "meetings.book.title": "New meeting",
  "meetings.detail.title": "Meeting details",
  "meetings.detail.not_found": "Meeting not found",
  "meetings.detail.not_found.description": "Unfortunately, we could not find this meeting",
  "meetings.detail.error": "Failed to load meeting",
  "meetings.book.error": "Failed to load expert's schedule",
  "meetings.book.submit_error": "Could not book the consultation. Please try again.",
  "meetings.zoom_pending": "The conference link is still being created. Refresh this page in a minute.",
  "meetings.book.not_found": "Schedule not found",
  "meetings.book.not_found.description": "Unfortunately, we could not find a schedule for this expert",
  "meetings.enrolled.error": "Failed to load meetings",
  "meetings.enrolled.none": "No meetings",
  "meetings.enrolled.upcoming.none": "Your upcoming meetings with clinical experts will be displayed here",
  "meetings.enrolled.finished.none": "Your finished meetings with clinical experts will be displayed here",
  "meetings.enrolled.all.none": "All your meetings with clinical experts will be displayed here",
  "meetings.book": "Schedule a meeting",
  "meetings.book.short": "Schedule",
  "meetings.about_expert": "About expert",
  "meetings.about_expert.dialog_description": "Expert information:",
  "meetings.about_expert.got_it": "Got it",
  "meetings.about_expert.specializations": "What to consult about:",
  "meetings.about_expert.watch_video": "Watch video",
  "meetings.nearest_slot": "Nearest slot",
  "meetings.nearest_slot.empty": "None",
  "meetings.feedback.ok": "Thank you for your feedback! Your review has been sent",
  "meetings.feedback.title": "Consulation feedback",
  "meetings.feedback.comment": "Comment",
  "meetings.feedback.rating": "Rating",
  "meetings.feedback.submit": "Send",
  "meetings.feedback.later": "Later",
  "meetings.feedback.description.1": "Dear doctor",
  "meetings.feedback.description.2": "you had an online meeting with a 3D Smile clinical expert",
  "meetings.feedback.description.p1": " on patient: ",
  "meetings.feedback.description.p2": " on patients: ",
  "meetings.feedback.description.3": "Please share your feedback on the consultation provided, this will help us become better for you.",
  "meetings.select_datetime": "Select date and time",
  "meetings.step": "Step {current} of {total}",
  "meetings.enter_details": "Enter your details",
  "meetings.no_time_available": "No time available",
  "meetings.form.name": "Doctor's full name",
  "meetings.form.name.required": "Please enter your name",
  "meetings.form.phone": "Phone number",
  "meetings.form.phone.required": "Please enter phone number",
  "meetings.form.phone.pattern": "Please check that the phone number you entered is correct",
  "meetings.form.email.required": "Please enter your email",
  "meetings.form.email.pattern": "Please enter email in the correct format",
  "meetings.form.patient": "Patient",
  "meetings.form.theme": "Theme",
  "meetings.form.theme.placeholder": "Select a theme",
  "meetings.form.question": "Question",
  "meetings.form.required": "This field is required",
  "meetings.form.add": "Add patient",
  "meetings.form.remove": "Remove patient",
  "meetings.book.success.title": "Congratulations! The meeting has been successfully booked.",
  "meetings.book.success.heading": "Congratulations!{br} The meeting has been successfully booked.",
  "meetings.book.success.another_expert": "Book another expert",
  "meetings.book.success.upcoming": "Go to upcoming appointments",

  "support.sidebar.title": "Contact Customer Support",
  "chat.title": "Chat",
  "chat.mini.back": "Back",
  "chat.thread_list.collapse": "Collapse chat list",
  "chat.thread_list.expand": "Expand chat list",
  "chat.thread_list.all": "All chats",
  "chat.support_banner.title": "Support team",
  "chat.support_banner.desc": "We're online and happy to help! We answer during business hours: weekdays, 9:00–18:00 (MSK)",
  "chat.channel.express_support": "Clinical express support",
  "chat.channel.express_support.subtitle": "Head of the 3D modeling department",
  "chat.channel.express_support.description": "Clinical case assessment, course selection, prescription drafting, and 3D plan questions.",
  "chat.channel.personal_technician": "3D modeler",
  "chat.channel.personal_technician.subtitle": "3D modeler",
  "chat.channel.personal_technician.description": "Adjusting the 3D plan to your goals directly with your technician",
  "chat.channel.personal_manager": "Personal manager",
  "chat.channel.personal_manager.subtitle": "Personal manager",
  "chat.channel.personal_manager.description": "Support with organizational and commercial matters",
  "chat.channel.care_department": "Care department",
  "chat.channel.care_department.subtitle": "Service and documents",
  "chat.channel.care_department.description": "Help with invoices, closing documents, and order statuses",
  "chat.media": "Media",
  "chat.tab.messages": "Chat",
  "chat.files.title": "Chat files",
  "chat.files.count": "{count, plural, one {# file} other {# files}}",
  "chat.files": "Files",
  "chat.media.empty": "No files",
  "chat.message.placeholder": "Enter a message",
  "chat.open.full": "Open fullscreen",
  "chat.send": "Send",
  "chat.attach": "Attach file",
  "chat.drop.title": "Sending files",
  "chat.drop.description.line1": "Drag photos and files here,",
  "chat.drop.description.line2": "to attach them to your message",
  "chat.image.preview.close": "Close",
  "chat.image.preview.download": "Download",
  "chat.video.expand": "Open in window",
  "chat.files.empty": "No files yet",
  "chat.upload.error": "Could not upload file",
  "chat.search.placeholder": "Search...",
  "chat.thread.search.placeholder": "Search...",
  "chat.thread.search.clear": "Clear search",
  "chat.thread.search.results": "{count, plural, =0 {No results} one {# result} other {# results}}",
  "chat.thread.search.empty": "Nothing found",
  "chat.unread_total": "{count, plural, one {# unread message} other {# unread messages}}",
  "chat.support_team": "Support team",
  "chat.support_team.subtitle": "We're here and happy to help!",
  "chat.support_team.hours": "We'll answer your questions during business hours:",
  "chat.support_team.hours_schedule": "weekdays, 9:00–18:00 (MSK)",
  "chat.readonly.no_assignee_notice":
    "This chat keeps your message history with your personal modeling technician from before.\nYou don't have a modeling technician assigned now, so you can't send messages.",
  "chat.readonly.no_assignee_notice_manager":
    "This chat keeps your message history with your personal manager from before.\nYou don't have a personal manager assigned now, so you can't send messages.",
  "chat.thread.empty_preview": "No messages yet",
  "chat.thread.file_only": "Attachments",
  "support.page.header": "Customer Support",
  "support.page.contacts.header": "Contact Our Support Team",
  "support.page.toll.free": "toll free number",
  "support.page.operating.hours": "Monday - Friday 9 AM - 6 PM EST",
  "support.page.onbording.btn": "Portal Onboarding",
  "support.page.onbording.btn.tooltip": "You will be redirected to the Calendly schedule page",
  "support.page.zoom.call.title": "Schedule a zoom call with customer support to learn more about our portal",

  "additional.aligners.both.comment": " ",

  events: "Events",
  "events.upcoming": "Schedule",
  "events.search": "Search..",
  "events.empty": "No events",
  "events.error": "Failed to load events",
  "events.upcoming.empty.heading": "No events yet",
  "events.upcoming.empty.description": "Events available for registration and purchase will be displayed here",
  "events.enrolled": "My events",
  "events.enrolled.empty.heading": "No upcoming or visited events yet",
  "events.enrolled.empty.description": "Your upcoming and visited events will be displayed here",
  "events.enrolled.empty.link": "Go to schedule",
  "events.recordings.empty.heading": "No video yet",
  "events.recordings.empty.description": "Your purchased event recordings will be displayed here",
  "events.recordings.empty.link": "Go to schedule",
  "events.recordings": "Media library",
  "events.search.placeholder": "Name",
  "events.filters": "Filters",
  "events.filters.reset": "Reset",
  "events.training_level.short": "Level",
  "events.all": "All",
  "events.meeting_type": "Format",
  "events.meeting_type.offline": "Offline",
  "events.meeting_type.online": "Online",
  "events.meeting_type.recording": "Video",
  "events.price": "Price",
  "events.price.free": "Free",
  "events.price.paid": "Paid",
  "events.training_level": "Training level",
  "events.training_level.0": "Beginner",
  "events.training_level.1": "Intermediate",
  "events.training_level.2": "Advanced",
  "events.city": "City",
  "events.not_found.heading": "No events found",
  "events.not_found.description": "Sorry, we couldn't find any events matching your search",
  "events.recording": "Video",
  "events.currency": "rub.",
  "events.free": "Free",
  "events.action.pay": "Pay",
  "events.action.pay.error": "Something went wrong while receiving the payment link. " + "Try again later",
  "events.action.zoom_join": "Join",
  "events.action.buy": "Buy",
  "events.action.get": "Get",
  "events.action.signup": "Sign up",
  "events.action.watch": "Watch",
  "events.action.feedback": "Leave feedback",
  "events.badge": "unpaid events",
  "events.video_available": "Video available",
  "events.watch_modal.title": "Go on {service}?",
  "events.watch_modal.description": "You are about to be redirected to {service} to watch the video",
  "events.watch_modal.open": "Go",
  "events.watch_modal.cancel": "Cancel",
  "events.zoom_modal.title": "Go on Zoom?",
  "events.zoom_modal.description": "You are about to be redirected to Zoom to join the meeting",
  "events.error.heading": "Error loading events",
  "events.error.description": "Try reloading the page or coming back later",
  "events.error.reset": "Retry",
  "events.not.found": "Events not found",
  "event.not.found": "Event not found",
  "events.rates.complimentary": "Complimentary",
  "events.rates.price": "Price",
  "events.rates.price.package": "Package price",
  "events.package.list": "Cycle events",
  "events.payments.package.pay": "Pay for the package",
  "events.enroll.success": "Registration process successfully completed",
  "events.enroll.error": "Error occurred trying to register to the event",
  "event.button.register": "Register",
  "event.button.zoom_join": "Join in Zoom",
  "event.payments": "Payment",
  "event.payments.money": "Total amount",
  "event.payments.smiles": "Price, smiles",
  "event.start.datetime": "Date and Time",
  "event.payment.smiles.total": 'Payment in "Smiles"',
  "events.payments.link.error": "Error occurred trying to proceed with a payment",
  "event.registration.payment.status": "Status",
  "event.registration.CREATED": "Request submitted",
  "event.registration.PROCESSING": "Waiting for a payment",
  "event.registration.PENDING": "Waiting for a payment",
  "event.registration.DECLINED": "Transaction declined",
  "event.registration.SUCCESS": "Payment completed ",
  "event.registration.CANCELED": "Canceled",
  "event.registration.enrolled": "Registered",
  "event.meeting_link": "Meeting link",
  "events.leave.feedback": "Leave a feedback about the event",
  "events.send.feedback.error": "Error occurred trying to send a feedback",
  "events.send.feedback.thanks": "Thank you for your feedback",
  "events.send.feedback.success": "Your feedback has been sent successfully!",
  "events.feedback.error": "Information not found",
  "events.payment.legal_entity": "Legal entity",
  "events.payment.email": "Email",
  "events.payment.email.hint": "(specify an email for which invoice is to be sent to)",
  "events.payment.email.doctor.hint": "(will be saved into your profile)",
  "events.payment.invoice.hint": "(if invoice will be paid by legal entity)",
  "events.offer.sign": "I confirm that I have read, understand and agree to ",
  "events.registration.completed": "No spots available",
  "events.registration.completed.verbose": "No spots available",
  "events.payment_status.goto": "Go to event",

  "toasts.yandex_metrika.text": "We use cookies to improve the performance of our website.",
  "toasts.telegram.text": "Latest news from the laboratory, event announcements in our Telegram channel",
  "toasts.telegram.goto": "Subscribe",

  // Agreements
  "agreement.title": "Supplementary agreement",
  "agreement.heading": "Supplementary agreement",
  "agreement.accept": "Accept",
  "agreement.reject": "Decline",
  "agreement.download": "Download",
  "agreement.pdf_error": "Something went wrong while loading the supplementary agreement",
  "agreement.notify.accept.success": "Supplementary agreement has been accepted",
  "agreement.notify.accept.error": "Error occurred accepting the supplementary agreement",
  "agreement.notify.reject.success": "Supplementary agreement has been declined",
  "agreement.notify.reject.error": "Error occurred rejecting the supplementary agreement",
  "agreements.table.error": "Error loading documents",
  "agreements.table.not_found": "Documents not found",
  "agreements.table.title": "Title",
  "agreements.table.status": "Status",
  "agreements.table.status.accepted": "Accepted",
  "agreements.table.status.rejected": "Declined",
  "agreements.table.status.pending": "Pending",
  "agreements.table.ends_at": "Valid until",

  // redesign-v1 (behind FEATURE_REDESIGN_V1)
  "redesign.common.not_set": "Not set",
  "redesign.common.yes": "Yes",
  "redesign.common.no": "No",
  "redesign.profile.title": "My profile",
  "redesign.profile.edit": "Edit",
  "redesign.profile.edit_full": "Edit",
  "redesign.profile.add": "Add",
  "redesign.profile.add_clinic": "Add clinic",
  "redesign.profile.logout": "Log out",
  "redesign.profile.section.info": "Profile information",
  "redesign.profile.section.clinics": "My clinics",
  "redesign.profile.section.prefs": "Clinical preferences",
  "redesign.profile.clinics.empty": "No clinics yet.",
  "redesign.profile.field.login": "Login",
  "redesign.profile.field.fio": "Full name",
  "redesign.profile.field.last_name": "Last name",
  "redesign.profile.field.first_name": "First name",
  "redesign.profile.field.middle_name": "Middle name",
  "redesign.profile.field.email": "E-mail",
  "redesign.profile.field.phone": "Phone",
  "redesign.profile.field.telegram": "Telegram ID",
  "redesign.profile.field.notifications": "Notifications",
  "redesign.profile.field.push": "Push",
  "redesign.profile.push.enable": "Enable push notifications",
  "redesign.profile.push.enabling": "Enabling…",
  "redesign.profile.push.enabled": "Push notifications on",
  "redesign.profile.push.disable": "Disable",
  "redesign.profile.push.error": "Couldn't enable push notifications",
  "redesign.profile.push.denied": "Notifications are blocked in the browser",
  "redesign.profile.push.denied_hint": "Open the site settings in your browser (or notification settings in the OS) and allow notifications for Doc LK, then reload the page.",
  "redesign.profile.push.stale": "Subscription is stale",
  "redesign.profile.push.stale_hint": "It looks like the notification subscription stopped working. Turn it on again.",
  "redesign.pwa.install.title.android": "Install Doc LK on your phone",
  "redesign.pwa.install.body.android": "The app will open right from your home screen — no browser, faster, with push notifications for important events.",
  "redesign.pwa.install.cta.android": "Install",
  "redesign.pwa.install.title.ios": "Install Doc LK on your iPhone",
  "redesign.pwa.install.body.ios": "Add Doc LK to your home screen — it will open separately from the browser, with push notifications for important events.",
  "redesign.pwa.install.step.ios.share": "Tap Share in the browser toolbar",
  "redesign.pwa.install.step.ios.add": 'Choose "Add to Home Screen"',
  "redesign.pwa.install.cta.ios": "Got it",
  "redesign.pwa.install.dismiss": "Not now",
  "redesign.pwa.push_primer.title": "Turn on notifications",
  "redesign.pwa.push_primer.body": "Doc LK can now send push notifications — about new messages, payments, meetings and other important events, even while the app is closed.",
  "redesign.pwa.push_primer.cta": "Enable",
  "redesign.pwa.push_primer.dismiss": "Not now",
  "redesign.profile.field.clinic_name": "Name",
  "redesign.profile.field.clinic_address": "Address",
  "redesign.profile.pref.separation": "Separation",
  "redesign.profile.pref.attachments": "Attachments",
  "redesign.profile.pref.expansion": "Expansion",
  "redesign.profile.pref.incisor_relationship": "Incisor relationship",
  "redesign.profile.pref.deep_bite": "Deep-bite intrusion + 1 mm",
  "redesign.profile.pref.extrusion": "Incisor extrusion + 1 mm",
  "redesign.profile.pref.rotation": "Rotation over 30° + 5°",
  "redesign.delivery.title": "Deliveries",
  "redesign.delivery.description": "Track your aligner deliveries here.",
  "redesign.delivery.date_label": "View from a selected date",
  "redesign.delivery.date_placeholder": "Select a date",
  "redesign.delivery.col.id": "ID",
  "redesign.delivery.col.patient": "Patient name",
  "redesign.delivery.col.tracking": "Tracking number",
  "redesign.payments.col.status": "Status",
  "redesign.payments.select_service": "Select a service",
  "redesign.payments.select_service_short": "Select",
  "redesign.payments.total_label": "Total to pay",
  "redesign.delivery.loading": "Loading…",
  "redesign.delivery.empty": "No deliveries found.",
  "redesign.clinic.title": "Add clinic",
  "redesign.clinic.submit": "Add clinic",
  "redesign.clinic.section.admin": "Administrative contacts",
  "redesign.clinic.section.delivery": "Delivery contacts",
  "redesign.clinic.schedule": "Working hours",
  "redesign.clinic.schedule.from": "from",
  "redesign.clinic.schedule.to": "to",
  "redesign.clinic.field.name": "Name",
  "redesign.clinic.field.email": "Clinic email",
  "redesign.clinic.field.address": "Address",
  "redesign.clinic.field.building": "Building",
  "redesign.clinic.field.city": "City",
  "redesign.clinic.field.zip": "Postal code",
  "redesign.clinic.field.phone": "Clinic phone number",
  "redesign.clinic.field.contact": "Who to contact about invoices and contracts",
  "redesign.clinic.field.logistic_phone": "Delivery service phone number (max 15 chars)",
  "redesign.clinic.field.logistic_contact": "Contact person for the delivery service (max 35 chars)",
  "redesign.clinic.ph.name": "Enter a name",
  "redesign.clinic.ph.email": "Enter an email",
  "redesign.clinic.ph.address": "Street (max 35 chars)",
  "redesign.clinic.ph.building": "Building / block (max 35 chars)",
  "redesign.clinic.ph.city": "City / country (max 35 chars)",
  "redesign.clinic.ph.zip": "Enter a postal code",
  "redesign.clinic.ph.phone": "Enter the clinic number",
  "redesign.clinic.ph.contact": "Enter a comment",
  "redesign.clinic.ph.logistic_phone": "Enter the delivery number",
  "redesign.clinic.ph.logistic_contact": "Enter a contact person",
  "redesign.clinic.err.required": "Required field",
  "redesign.clinic.err.email": "Enter a valid email",
  "redesign.clinic.err.zip": "Enter a valid postal code",
  "redesign.clinic.err.phone": "Enter a valid phone number",
  "redesign.clinic.day.mon": "Monday",
  "redesign.clinic.day.tue": "Tuesday",
  "redesign.clinic.day.wed": "Wednesday",
  "redesign.clinic.day.thu": "Thursday",
  "redesign.clinic.day.fri": "Friday",
  "redesign.clinic.day.sat": "Saturday",
  "redesign.clinic.day.sun": "Sunday",
  "redesign.profile_edit.change_password": "Change password",
  "redesign.common.editing": "Editing",
  "redesign.clinic_view.title": "Clinic information",
  "redesign.clinic_view.field.clinic": "Clinic",
  "redesign.clinic_view.field.email": "Clinic e-mail",
  "redesign.clinic_view.field.address": "Clinic address",
  "redesign.clinic_view.field.zip": "Postal code",
  "redesign.clinic_view.field.phone": "Clinic phone number",
  "redesign.clinic_view.field.contact": "Contact details",
  "redesign.clinic_view.field.logistic_phone": "Delivery service phone number",
  "redesign.clinic_view.field.logistic_contact": "Delivery service contact person",
  "redesign.clinic_view.schedule": "Working hours",
  "redesign.prefs.title": "Clinical preferences",
  "redesign.prefs.submit": "Save changes",
  "redesign.prefs.err.int_range": "Enter a whole number from 1 to 99",
  "redesign.prefs.err.float_min": "Value must be at least 1.0",
  "redesign.prefs.separation": "Separation (perform IPR)",
  "redesign.prefs.ipr_start": "Start IPR from step",
  "redesign.prefs.attachments": "Attachments (place on step)",
  "redesign.prefs.expansion": "Expansion (always expand)",
  "redesign.prefs.incisors": "Incisor relationship",
  "redesign.prefs.overjet": "Incisor relationship, horizontal (mm)",
  "redesign.prefs.overbite": "Incisor relationship, vertical (mm)",
  "redesign.prefs.stepper.up": "Increase value",
  "redesign.prefs.stepper.down": "Decrease value",
  "redesign.prefs.angulation": "Upper incisor torque (degrees)",
  "redesign.prefs.overcorrection": "Overcorrection",
  "redesign.prefs.deep_bite": "Deep-bite intrusion + 1 mm",
  "redesign.prefs.extrusion": "Incisor extrusion + 1 mm",
  "redesign.prefs.rotation": "Rotation over 30° + 5°",
  "redesign.prefs.additional": "Additional",
  "redesign.prefs.ph.value": "Enter a value",
  "redesign.prefs.ph.additional": "Additional clinical preferences for most patients",
  "redesign.profile_edit.title": "Profile information",
  "redesign.profile_edit.submit": "Save changes",
  "redesign.profile_edit.ph.email": "Enter an email",
  "redesign.profile_edit.ph.phone": "Enter a phone number",
  "redesign.profile_edit.ph.telegram": "Enter a Telegram ID",
  "redesign.profile_edit.notify_telegram": "Telegram",
  "redesign.profile_edit.notify_email": "Email",
  "redesign.nav.achievements": "My achievements",
  "redesign.nav.patients": "Patients",
  "redesign.nav.payments": "Payments",
  "redesign.nav.delivery": "Delivery",
  "redesign.nav.chat": "Chat",
  "redesign.nav.learning": "Events",
  "redesign.nav.consultations": "Expert consultations",
  "redesign.nav.cases": "Clinical cases",
  "redesign.nav.instructions": "Instructions",
  "redesign.nav.documents": "Documents",
  "redesign.nav.materials": "Patient materials",
  "redesign.nav.more": "Menu",
  "redesign.shell.call": "Call",
  "redesign.shell.phone_copied": "Phone number copied",
  "redesign.shell.write": "Message",
  "redesign.shell.logout": "Log out",
  "redesign.shell.edit_profile": "Edit profile",
  "redesign.shell.breadcrumbs": "Breadcrumbs",
  "redesign.shell.home": "Home",
  "redesign.shell.patient": "Patient {id}",
  // Breadcrumbs for legacy pages rendered inside the redesign shell.
  "redesign.shell.online_payment": "Online payment",
  "redesign.shell.elite": "3D Smile Elite",

  "redesign.shell.all_deliveries": "All shipments",
  "redesign.shell.event_detail": "Description",
  "redesign.shell.scrollToTop": "Scroll to top",
  "redesign.patient_form.required_banner": "Fields marked with <accent>*</accent> are required.",
  "redesign.patient.form.ct.zip_hint": "Archive files (.zip) are accepted",
  "redesign.patient.form.ct.link_placeholder": "Enter a CT link",
  "redesign.shell.manager": "Your manager",
  "redesign.shell.help.title": "Need help?",
  "redesign.shell.help.desc": "We'll help you sort out your question.",
  "redesign.shell.help.cta": "Ask a question",
  "redesign.shell.contacts": "Contacts: +7 (495) 211-44-54",
  "redesign.shell.copyright": "{year} © OOO «3D Smile»",
  "redesign.patient.delivery.header": "Impression delivery",
  "redesign.consult.title": "Consultations with a clinical expert",
  "redesign.consult.tab.new": "New booking",
  "redesign.consult.tab.upcoming": "Upcoming",
  "redesign.consult.tab.done": "Completed",
  "redesign.consult.tab.all": "All",
  "redesign.consult.expertLabel": "Clinical expert",
  "redesign.consult.slot": "Nearest available appointment: {when}",
  "redesign.consult.noSlot": "Nearest available appointment: none",
  "redesign.consult.about": "About the expert",
  "redesign.consult.book": "Book",
  "redesign.consult.empty": "Nothing here yet.",
  "redesign.consult.error": "Couldn't load the experts. Please try again.",
  "redesign.shell.doctor": "Doctor",
  "redesign.patients.search": "Find a patient...",
  "redesign.patients.search_placeholder": "Search...",
  "redesign.patients.payment_alert": "You have unpaid stages — please review the payments.",
  "redesign.patients.add": "Add patient",
  "redesign.patients.col.patient": "Patient",
  "redesign.patients.col.status": "Status",
  "redesign.patients.status_filter.clear": "Clear",
  "redesign.back": "Back",
  "redesign.pv.plan.title": "3D plan",
  "redesign.pv.plan.title.pending": "3D plan for approval",
  "redesign.pv.plan.view": "View 3D plan",
  "redesign.pv.card.title": "Patient card",
  "redesign.pv.card.edit": "Edit",
  "redesign.pv.payment.title": "Payment status",
  "redesign.pv.main_treatment": "Main treatment",
  "redesign.pv.comments.history": "Message history",
  "redesign.pv.comments.placeholder": "Enter a comment",
  "redesign.patients.tab.all": "All patients",
  "redesign.patients.tab.waiting": "Awaiting action",
  "redesign.patients.tab.working": "In progress",
  "redesign.patients.tab.drafts": "Drafts",
  "redesign.patients.tab.done": "Completed",
  "redesign.patients.tab.canceled": "Not started",
  "redesign.patients.prev": "Previous",
  "redesign.patients.next": "Next",
  // The education card's online-format badge. Redesign-scoped because the frame says "Вебинар" where the
  // shared `events.meeting_type.online` says "Онлайн" — renaming that id would re-copy the legacy page.
  "redesign.education.format.online": "Webinar",
  // Desktop uses "Enter a name" while mobile uses the shared `events.search` message ("Search..").
  "redesign.education.search.desktop": "Enter a name",
  // Placeholder for the redesign event feedback field.
  "redesign.event.feedback.placeholder": "Enter text",
  "redesign.patients.pageOf": "{page} of {total}",
  "redesign.patients.first": "First page",
  "redesign.patients.last": "Last page",
  // — "My achievements" (dashboard, frames 7685-30220 / 7686-31581) —
  "redesign.dashboard.greeting.night": "Good night, {name}!",
  "redesign.dashboard.greeting.morning": "Good morning, {name}!",
  "redesign.dashboard.greeting.day": "Good afternoon, {name}!",
  "redesign.dashboard.greeting.evening": "Good evening, {name}!",
  "redesign.dashboard.tenure":
    "You have been building clinical history with 3D Smile for {years, plural, =0 {} one {# year} other {# years}}{years, plural, =0 {} other { }}{months, plural, =0 {} one {and # month} other {and # months}}.{br}Here are the highlights of that journey.",
  "redesign.dashboard.tenure.unknown": "Here are the highlights of your work with 3D Smile.",
  "redesign.dashboard.orders.title": "Order dynamics",
  "redesign.dashboard.orders.hint":
    "The statistics cover orders over the whole history of cooperation. Patients with the statuses «Недозаполненная заявка» and «Отказался от лечения» are not counted.",
  "redesign.dashboard.orders.hint.year": "The statistics cover orders for the selected period. Patients with the statuses «Недозаполненная заявка» and «Отказался от лечения» are not counted.",
  "redesign.dashboard.orders.patients": "{count, plural, one {Patient over the whole period} other {Patients over the whole period}}",
  "redesign.dashboard.orders.active": "Active orders",
  "redesign.dashboard.orders.drafts": "Drafts",
  "redesign.dashboard.orders.other": "Other courses",
  "redesign.dashboard.course.unlimited": "Course with CT",
  "redesign.dashboard.course.oneJaw": "One jaw",
  "redesign.dashboard.orders.percent": "{percent}%",
  "redesign.dashboard.year.prev": "Previous year",
  "redesign.dashboard.year.next": "Next year",
  "redesign.dashboard.speed.title": "Process speed and its effect on compliance",
  "redesign.dashboard.speed.hint": "Figures are calculated over calendar months. With the «1 month» period selected, the window runs from the 1st of the current month to today.",
  "redesign.dashboard.period.1m": "1 mo",
  "redesign.dashboard.period.3m": "3 mo",
  "redesign.dashboard.period.6m": "6 mo",
  "redesign.dashboard.plan.versions": "Average number of 3D Plan versions",
  "redesign.dashboard.plan.approval": "Average 3D Plan approval time",
  "redesign.dashboard.plan.patients": "Total number of patients",
  "redesign.dashboard.plan.refinements": "Average number of refinements",
  "redesign.dashboard.confidence.title": "Clinical confidence",
  "redesign.dashboard.confidence.hint": "Consultations and events are counted over the whole history of cooperation. Only those marked as held are counted.",
  "redesign.dashboard.engagement.consultations": "Consultations completed",
  "redesign.dashboard.engagement.events": "Events attended",
  "redesign.dashboard.unit.versions": "{count, plural, one {version} other {versions}}",
  "redesign.dashboard.unit.days": "{count, plural, one {day} other {days}}",
  "redesign.dashboard.unit.patients": "{count, plural, one {patient} other {patients}}",
  "redesign.dashboard.unit.refinements": "{count, plural, one {refinement} other {refinements}}",
  "redesign.dashboard.unit.consultations": "{count, plural, one {consultation} other {consultations}}",
  "redesign.dashboard.unit.events": "{count, plural, one {event} other {events}}",
  "redesign.dashboard.engagement.booked": "of {booked} booked",
  "redesign.dashboard.no.data": "—",

  "maintenance.heading": "Dear Doctor! The personal account is temporarily unavailable",
  "viewer.refresh": "Refresh versions",
  "viewer.title": "3D plan v5",
  "viewer.open": "Open 3D plan v5",
  "viewer.versions": "3D plan versions",
  "viewer.open.version": "Open",
  "viewer.watch": "View",
  "viewer.link": "Patient link",
  "viewer.date": "Date",
  "viewer.plan.name": "Plan name",
  "viewer.actions": "Actions",
  "viewer.status": "Status",
  "viewer.available.since": "Available for approval since {date}",
  "viewer.legacy.plan": "3D plan",
  "viewer.open.selected": "Open: {correction, select, 0 {main treatment} other {correction {correction}}}, version {version}",
  "viewer.archive": "3D plan archive",
  "viewer.archive.count": "{count, plural, one {# version} other {# versions}}",
  "viewer.archive.plans.count": "{count, plural, one {# plan} other {# plans}}",
  "viewer.previous.plan": "Previous plan",
  "viewer.public.unavailable": "This plan link is unavailable. Please contact your doctor.",
  "viewer.share.error": "Could not copy the link. Please try again.",
  "viewer.share.selected": "Share 3D plan: {correction, select, 0 {main treatment} other {correction {correction}}}, version {version}",
  "viewer.report": "Report",
  "viewer.report.selected": "Report: {correction, select, 0 {main treatment} other {correction {correction}}}, version {version}",
  "viewer.report.unavailable": "Report unavailable",
  "viewer.version": "Version",
  "viewer.version.option": "{correction, select, 0 {Main treatment} other {Correction {correction}}}, version {version}",
  "viewer.state.draft": "Draft",
  "viewer.state.pending": "Awaiting review",
  "viewer.state.rework": "Rework requested",
  "viewer.state.approved": "Approved",
  "viewer.state.not_approved": "Not approved",
  "viewer.close": "Close",
  "viewer.empty": "No available versions",
  "viewer.loading": "Loading…",
  "viewer.load.error": "Could not load the viewer.",
  "viewer.list.error": "Could not load plan versions.",
  "viewer.action.error": "The request failed. Please try again.",
  "viewer.refresh.required": "Changes were saved. Refresh the data to continue.",
  "viewer.retry": "Retry",
  "viewer.approve": "Approve plan",
  "viewer.rework": "Request rework",
  "viewer.consent": "I have read and accept the terms",
  "viewer.approve.profile.required": "The doctor name and patient clinic must be completed before approval.",
  "viewer.remarks": "Comment on the 3D plan",
  "viewer.comment.required": "Enter a comment.",
  "viewer.submit": "Submit",
  "viewer.rework.submit": "Send for rework",
  "viewer.cancel": "Cancel",
  "viewer.comments": "Version comments",
  "viewer.comments.error": "Could not load comments.",
  "viewer.comments.empty": "No comments yet.",
  "viewer.comment": "Comment",
};

export default messages;
